// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { PutApiUserByUserIdData, PutApiUserByUserIdResponse, DeleteApiUserByUserIdData, DeleteApiUserByUserIdResponse, GetApiUserMeResponse, PutApiUserMeData, PutApiUserMeResponse, DeleteApiUserMeResponse, PostApiUserData, PostApiUserResponse, PostApiUserByUserIdPromoteToAdminData, PostApiUserByUserIdPromoteToAdminResponse, PostApiUserByUserIdDemoteFromAdminData, PostApiUserByUserIdDemoteFromAdminResponse, PostApiUserVerifyDomainAccessData, PostApiUserVerifyDomainAccessResponse, PostApiUserMeAvatarData, PostApiUserMeAvatarResponse, GetApiUserDomainResponse, GetApiTasksByIdData, GetApiTasksByIdResponse, PutApiTasksByIdData, PutApiTasksByIdResponse, DeleteApiTasksByIdData, DeleteApiTasksByIdResponse, PutApiTasksByIdUnassignData, PutApiTasksByIdUnassignResponse, PutApiTasksByIdPriorityByPriorityData, PutApiTasksByIdPriorityByPriorityResponse, PutApiTasksByIdAssignByKeycloakUserIdData, PutApiTasksByIdAssignByKeycloakUserIdResponse, GetApiTasksResponse, PostApiTasksData, PostApiTasksResponse, GetApiTasksByTaskIdHistoryData, GetApiTasksByTaskIdHistoryResponse, GetApiTasksUnassignedResponse, GetApiTasksStatusByStatusData, GetApiTasksStatusByStatusResponse, GetApiTasksStatsUserByKeycloakUserIdHasAssignedData, GetApiTasksStatsUserByKeycloakUserIdHasAssignedResponse, GetApiTasksStatsUserByKeycloakUserIdCreatedCountData, GetApiTasksStatsUserByKeycloakUserIdCreatedCountResponse, GetApiTasksStatsUserByKeycloakUserIdAssignedCountData, GetApiTasksStatsUserByKeycloakUserIdAssignedCountResponse, GetApiTasksStatsTotalCountResponse, GetApiTasksStatsStatusByStatusCountData, GetApiTasksStatsStatusByStatusCountResponse, GetApiTasksStatsPriorityByPriorityCountData, GetApiTasksStatsPriorityByPriorityCountResponse, GetApiTasksStatsMyHasAssignedResponse, GetApiTasksStatsMyCreatedCountResponse, GetApiTasksStatsMyAssignedCountResponse, GetApiTasksStatsComprehensiveResponse, GetApiTasksStartDateBetweenData, GetApiTasksStartDateBetweenResponse, GetApiTasksRecentData, GetApiTasksRecentResponse, GetApiTasksPriorityByPriorityData, GetApiTasksPriorityByPriorityResponse, GetApiTasksPaginatedData, GetApiTasksPaginatedResponse, GetApiTasksOverdueResponse, GetApiTasksMyCreatedResponse, GetApiTasksMyAssignedResponse, GetApiTasksMyAssignedStatusByStatusData, GetApiTasksMyAssignedStatusByStatusResponse, GetApiTasksMyAssignedOverdueResponse, GetApiTasksEndDateBetweenData, GetApiTasksEndDateBetweenResponse, GetApiTasksCreatedAtBetweenData, GetApiTasksCreatedAtBetweenResponse, GetApiTasksCreatedByByKeycloakUserIdData, GetApiTasksCreatedByByKeycloakUserIdResponse, GetApiTasksAssignedToByKeycloakUserIdData, GetApiTasksAssignedToByKeycloakUserIdResponse, GetApiTasksAssignedToByKeycloakUserIdStatusByStatusData, GetApiTasksAssignedToByKeycloakUserIdStatusByStatusResponse, GetApiTasksAssignedToByKeycloakUserIdOverdueData, GetApiTasksAssignedToByKeycloakUserIdOverdueResponse, GetApiPredefinedLeadAttributesByIdData, GetApiPredefinedLeadAttributesByIdResponse, PutApiPredefinedLeadAttributesByIdData, PutApiPredefinedLeadAttributesByIdResponse, DeleteApiPredefinedLeadAttributesByIdData, DeleteApiPredefinedLeadAttributesByIdResponse, GetApiPredefinedLeadAttributesResponse, PostApiPredefinedLeadAttributesData, PostApiPredefinedLeadAttributesResponse, GetApiLeadContactsPredefinedAttributesResponse, GetApiOffersByIdData, GetApiOffersByIdResponse, PutApiOffersByIdData, PutApiOffersByIdResponse, DeleteApiOffersByIdData, DeleteApiOffersByIdResponse, GetApiOffersResponse, PostApiOffersData, PostApiOffersResponse, GetApiOffersTypeByTypeData, GetApiOffersTypeByTypeResponse, GetApiOffersSearchData, GetApiOffersSearchResponse, GetApiLeadContactsByIdData, GetApiLeadContactsByIdResponse, PutApiLeadContactsByIdData, PutApiLeadContactsByIdResponse, DeleteApiLeadContactsByIdData, DeleteApiLeadContactsByIdResponse, GetApiLeadContactsResponse, PostApiLeadContactsData, PostApiLeadContactsResponse, GetApiLeadContactsPaginatedData, GetApiLeadContactsPaginatedResponse, PutApiKanbanTasksByTaskIdStatusData, PutApiKanbanTasksByTaskIdStatusResponse, GetApiKanbanBoardData, GetApiKanbanBoardResponse, GetApiKanbanBoardStatusByStatusData, GetApiKanbanBoardStatusByStatusResponse, GetApiConfigPrefixByPrefixTypeData, GetApiConfigPrefixByPrefixTypeResponse, PutApiConfigPrefixByPrefixTypeData, PutApiConfigPrefixByPrefixTypeResponse, GetApiConfigPrefixResponse, GetApiConfigPrefixAllResponse, GetApiCommentsByIdData, GetApiCommentsByIdResponse, PutApiCommentsByIdData, PutApiCommentsByIdResponse, DeleteApiCommentsByIdData, DeleteApiCommentsByIdResponse, GetApiCommentsData, GetApiCommentsResponse, PostApiCommentsData, PostApiCommentsResponse, GetApiCommentsUserByUserIdCountData, GetApiCommentsUserByUserIdCountResponse, GetApiCommentsMyResponse, GetApiCommentsMyCountResponse, GetApiCommentsMentionsUserByUserIdData, GetApiCommentsMentionsUserByUserIdResponse, GetApiCommentsMentionsUserByUserIdExistsData, GetApiCommentsMentionsUserByUserIdExistsResponse, GetApiCommentsMentionsUserByUserIdCountData, GetApiCommentsMentionsUserByUserIdCountResponse, GetApiCommentsMentionsObjectByObjectIdData, GetApiCommentsMentionsObjectByObjectIdResponse, GetApiCommentsMentionsObjectByObjectIdCountData, GetApiCommentsMentionsObjectByObjectIdCountResponse, GetApiCommentsMentionsMyResponse, GetApiCommentsMentionsMyExistsResponse, GetApiCommentsMentionsMyCountResponse, GetApiCommentsMentionsAllResponse, GetApiCommentsAllResponse, GetApiAttributesByIdData, GetApiAttributesByIdResponse, PutApiAttributesByIdData, PutApiAttributesByIdResponse, DeleteApiAttributesByIdData, DeleteApiAttributesByIdResponse, PutApiAttributesBulkData, PutApiAttributesBulkResponse, PostApiAttributesBulkData, PostApiAttributesBulkResponse, GetApiAttributesResponse, PostApiAttributesData, PostApiAttributesResponse, GetApiAttributesObjectByObjectTypeByObjectIdData, GetApiAttributesObjectByObjectTypeByObjectIdResponse, DeleteApiAttributesObjectByObjectTypeByObjectIdData, DeleteApiAttributesObjectByObjectTypeByObjectIdResponse, PutAcquisitionTypesByIdData, PutAcquisitionTypesByIdResponse, DeleteAcquisitionTypesByIdData, DeleteAcquisitionTypesByIdResponse, GetAcquisitionTypesResponse, PostAcquisitionTypesData, PostAcquisitionTypesResponse, PostApiWelcomeImagesGenerateData, PostApiWelcomeImagesGenerateResponse, PostApiWelcomeImagesGenerateTodayResponse, GetApiWelcomeImagesTodayResponse, GetApiWelcomeImagesImageData, GetApiWelcomeImagesImageResponse, GetApiWelcomeImagesGenerateNowResponse, PostApiV1UserAvatarsSelectData, PostApiV1UserAvatarsSelectResponse, GetApiV1UserAvatarsByUserIdData, GetApiV1UserAvatarsByUserIdResponse, GetApiV1UserAvatarsAvailableResponse, PostApiLeadTasksAssignTasksToLeadData, PostApiLeadTasksAssignTasksToLeadResponse, PostApiLeadTasksAssignLeadsToTaskData, PostApiLeadTasksAssignLeadsToTaskResponse, GetApiLeadTasksTaskByTaskIdLeadsData, GetApiLeadTasksTaskByTaskIdLeadsResponse, GetApiLeadTasksTaskByTaskIdLeadsCountData, GetApiLeadTasksTaskByTaskIdLeadsCountResponse, GetApiLeadTasksLeadByLeadIdTasksData, GetApiLeadTasksLeadByLeadIdTasksResponse, GetApiLeadTasksLeadByLeadIdTasksCountData, GetApiLeadTasksLeadByLeadIdTasksCountResponse, GetApiLeadTasksLeadByLeadIdTaskByTaskIdExistsData, GetApiLeadTasksLeadByLeadIdTaskByTaskIdExistsResponse, DeleteApiLeadTasksDetachTasksFromLeadData, DeleteApiLeadTasksDetachTasksFromLeadResponse, DeleteApiLeadTasksDetachLeadsFromTaskData, DeleteApiLeadTasksDetachLeadsFromTaskResponse, PostApiLeadContactsImportExcelWithProgressData, PostApiLeadContactsImportExcelWithProgressResponse, PostApiLeadContactsImportExcelData, PostApiLeadContactsImportExcelResponse, PostApiLeadContactsExportFilteredLeadsData, PostApiLeadContactsExportFilteredLeadsResponse, GetApiLeadContactsImportStatusByImportIdData, GetApiLeadContactsImportStatusByImportIdResponse, GetApiLeadContactsImportProgressByImportIdData, GetApiLeadContactsImportProgressByImportIdResponse, GetApiLeadContactsImportHistoryData, GetApiLeadContactsImportHistoryResponse, GetApiLeadContactsImportHistoryByImportIdData, GetApiLeadContactsImportHistoryByImportIdResponse, GetApiLeadContactsImportHistoryUserByUsernameData, GetApiLeadContactsImportHistoryUserByUsernameResponse, GetApiLeadContactsExportLeadsPaginatedData, GetApiLeadContactsExportLeadsPaginatedResponse, GetApiLeadContactsExportLeadsByDateRangeData, GetApiLeadContactsExportLeadsByDateRangeResponse, GetApiLeadContactsExportAllLeadsResponse, GetApiLeadContactsExcelTemplateResponse, PostApiHelpContactData, PostApiHelpContactResponse, PostApiFilesUploadData, PostApiFilesUploadResponse, PatchApiFilesByFilenameStatusData, PatchApiFilesByFilenameStatusResponse, PatchApiFilesBulkStatusData, PatchApiFilesBulkStatusResponse, GetApiFilesResponse, GetApiFilesByFilenameThumbnailData, GetApiFilesByFilenameThumbnailResponse, GetApiFilesByFilenameDownloadData, GetApiFilesByFilenameDownloadResponse, GetApiFilesStorageInfoResponse, GetApiFilesMyFilesResponse, GetApiFilesByRelatedObjectByIdByTypeData, GetApiFilesByRelatedObjectByIdByTypeResponse, DeleteApiFilesByFilenameData, DeleteApiFilesByFilenameResponse, DeleteApiFilesBulkData, DeleteApiFilesBulkResponse, GetApiCompanyLogoResponse, PostApiCompanyLogoData, PostApiCompanyLogoResponse, DeleteApiCompanyLogoResponse, PostApiAuthRegisterConfirmData, PostApiAuthRegisterConfirmResponse, PostApiAuthRegisterData, PostApiAuthRegisterResponse, GetApiAuthRegisterCheckEmailData, GetApiAuthRegisterCheckEmailResponse, GetApiAuthRegisterCheckDomainData, GetApiAuthRegisterCheckDomainResponse, PostApiAuthPasswordResetData, PostApiAuthPasswordResetResponse, PostApiAuthPasswordResetRequestData, PostApiAuthPasswordResetRequestResponse, GetApiAuthPasswordValidateData, GetApiAuthPasswordValidateResponse, GetApiAlertsResponse, PostApiAlertsData, PostApiAlertsResponse, PostApiAlertsByIdCompleteData, PostApiAlertsByIdCompleteResponse, PostApiAlertsUserByUserIdCompleteAllData, PostApiAlertsUserByUserIdCompleteAllResponse, PostApiAlertsOverdueCompleteResponse, GetApiAlertsUserByUserIdData, GetApiAlertsUserByUserIdResponse, GetApiAlertsUserByUserIdTaskByTaskIdData, GetApiAlertsUserByUserIdTaskByTaskIdResponse, GetApiAlertsUserByUserIdStatusData, GetApiAlertsUserByUserIdStatusResponse, GetApiAlertsTaskByTaskIdData, GetApiAlertsTaskByTaskIdResponse, GetApiAlertsTaskByTaskIdStatusData, GetApiAlertsTaskByTaskIdStatusResponse, GetApiAlertsStatusData, GetApiAlertsStatusResponse, GetApiAlertsRemindOptionsResponse, PostAnalyticsData, PostAnalyticsResponse, GetLogoByFilenameData, GetLogoByFilenameResponse, GetApiSearchByTypeData, GetApiSearchByTypeResponse, GetApiSearchData, GetApiSearchResponse, GetApiReportsTasksByTaskIdStatusDurationData, GetApiReportsTasksByTaskIdStatusDurationResponse, GetApiReportsTasksStatusSummaryResponse, GetApiReportsTasksLastDaysCountResponse, GetApiReportsLeadsLastDaysCountResponse, GetApiLeadContactsSearchData, GetApiLeadContactsSearchResponse, GetApiCarouselStatsResponse, GetApiCarouselDailyImageResponse } from './types.gen';

export class UserService {
    /**
     * Aktualizuj dane użytkownika (tylko dla administratora)
     * Aktualizuje dane (email, imię, nazwisko, atrybuty) wskazanego użytkownika. Uwaga: Aktualizacja adresu email może być ograniczona przez konfigurację Keycloak.
     * @param data The data for the request.
     * @param data.userId ID użytkownika
     * @param data.requestBody
     * @returns string Dane użytkownika zaktualizowane pomyślnie
     * @throws ApiError
     */
    public static putApiUserByUserId(data: PutApiUserByUserIdData): CancelablePromise<PutApiUserByUserIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/{userId}',
            path: {
                userId: data.userId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Nieprawidłowe dane wejściowe',
                401: 'Brak autoryzacji',
                403: 'Brak uprawnień lub brak możliwości zmiany adresu email (ograniczenie Keycloak)',
                404: 'Użytkownik nie istnieje',
                500: 'Wewnętrzny błąd serwera'
            }
        });
    }
    
    /**
     * Usuń użytkownika (tylko dla administratora)
     * Usuwa wskazanego użytkownika z systemu. Jeśli użytkownik ma rolę api-admin, usuwa całą grupę wraz z wszystkimi członkami. Wszyscy użytkownicy otrzymają email potwierdzający usunięcie konta.
     * @param data The data for the request.
     * @param data.userId ID użytkownika do usunięcia
     * @returns string Użytkownik został pomyślnie usunięty
     * @throws ApiError
     */
    public static deleteApiUserByUserId(data: DeleteApiUserByUserIdData): CancelablePromise<DeleteApiUserByUserIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/user/{userId}',
            path: {
                userId: data.userId
            },
            errors: {
                400: 'Nieprawidłowy ID użytkownika',
                401: 'Brak autoryzacji',
                403: 'Brak uprawnień administratora',
                404: 'Użytkownik nie istnieje',
                500: 'Wewnętrzny błąd serwera'
            }
        });
    }
    
    /**
     * Pobierz informacje o aktualnie zalogowanym użytkowniku
     * Zwraca szczegółowe informacje o aktualnie zalogowanym użytkowniku w obrębie jego domeny
     * @returns CurrentUserInfoDTO Informacje pobrane pomyślnie
     * @throws ApiError
     */
    public static getApiUserMe(): CancelablePromise<GetApiUserMeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/me',
            errors: {
                401: 'Brak autoryzacji',
                403: 'Brak dostępu do domeny',
                404: 'Użytkownik nie znaleziony'
            }
        });
    }
    
    /**
     * Aktualizuj dane aktualnie zalogowanego użytkownika
     * Aktualizuje dane (email, imię, nazwisko, atrybuty) aktualnie zalogowanego użytkownika. Uwaga: Aktualizacja adresu email może być ograniczona przez konfigurację Keycloak.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns string Dane użytkownika zaktualizowane pomyślnie
     * @throws ApiError
     */
    public static putApiUserMe(data: PutApiUserMeData): CancelablePromise<PutApiUserMeResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/me',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Nieprawidłowe dane wejściowe',
                401: 'Brak autoryzacji',
                403: 'Brak możliwości zmiany adresu email (ograniczenie Keycloak)',
                500: 'Wewnętrzny błąd serwera'
            }
        });
    }
    
    /**
     * Usuń własne konto
     * Usuwa konto aktualnie zalogowanego użytkownika. Po usunięciu konta nastąpi automatyczne wylogowanie. Jeśli użytkownik ma rolę api-admin, zostanie usunięta cała grupa wraz z wszystkimi członkami. Otrzymasz email potwierdzający usunięcie konta.
     * @returns string Konto zostało pomyślnie usunięte
     * @throws ApiError
     */
    public static deleteApiUserMe(): CancelablePromise<DeleteApiUserMeResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/user/me',
            errors: {
                401: 'Brak autoryzacji',
                500: 'Wewnętrzny błąd serwera'
            }
        });
    }
    
    /**
     * Utwórz nowego użytkownika
     * Tworzy nowego użytkownika w systemie Keycloak
     * @param data The data for the request.
     * @param data.requestBody
     * @returns string Użytkownik utworzony pomyślnie
     * @throws ApiError
     */
    public static postApiUser(data: PostApiUserData): CancelablePromise<PostApiUserResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Nieprawidłowe dane wejściowe',
                500: 'Wewnętrzny błąd serwera'
            }
        });
    }
    
    /**
     * Promuj użytkownika do roli ADMIN
     * Nadaje użytkownikowi rolę `api-admin` (oraz opcjonalnie usuwa `api-user`).
     * @param data The data for the request.
     * @param data.userId ID użytkownika
     * @returns string Rola zmieniona pomyślnie
     * @throws ApiError
     */
    public static postApiUserByUserIdPromoteToAdmin(data: PostApiUserByUserIdPromoteToAdminData): CancelablePromise<PostApiUserByUserIdPromoteToAdminResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/{userId}/promote-to-admin',
            path: {
                userId: data.userId
            },
            errors: {
                404: 'Użytkownik nie istnieje',
                500: 'Wewnętrzny błąd serwera'
            }
        });
    }
    
    /**
     * Degraduj użytkownika z roli ADMIN
     * Usuwa użytkownikowi rolę `api-admin` i nadaje rolę `api-user`.
     * @param data The data for the request.
     * @param data.userId ID użytkownika
     * @returns string Rola zmieniona pomyślnie
     * @throws ApiError
     */
    public static postApiUserByUserIdDemoteFromAdmin(data: PostApiUserByUserIdDemoteFromAdminData): CancelablePromise<PostApiUserByUserIdDemoteFromAdminResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/{userId}/demote-from-admin',
            path: {
                userId: data.userId
            },
            errors: {
                404: 'Użytkownik nie istnieje',
                500: 'Wewnętrzny błąd serwera'
            }
        });
    }
    
    /**
     * Weryfikuje dostęp użytkownika do subdomeny
     * Sprawdza czy użytkownik należy do grupy w Keycloak odpowiadającej subdomenie wyciągniętej z nagłówka Host requestu. Dla profili dev, dev-with-local-mail i local - requesty z localhost zawsze zwracają status 200.
     * @param data The data for the request.
     * @param data.username Login użytkownika
     * @returns string Dostęp dozwolony
     * @throws ApiError
     */
    public static postApiUserVerifyDomainAccess(data: PostApiUserVerifyDomainAccessData): CancelablePromise<PostApiUserVerifyDomainAccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/verify-domain-access',
            query: {
                username: data.username
            },
            errors: {
                400: 'Nieprawidłowe parametry wejściowe lub brak domeny w requestcie',
                401: 'Brak dostępu - domena nie pasuje do grupy użytkownika',
                500: 'Błąd serwera podczas weryfikacji dostępu'
            }
        });
    }
    
    /**
     * Wgraj avatar użytkownika
     * Wgrywa avatar dla aktualnie zalogowanego użytkownika
     * @param data The data for the request.
     * @param data.formData
     * @returns unknown Avatar został pomyślnie wgrany
     * @throws ApiError
     */
    public static postApiUserMeAvatar(data: PostApiUserMeAvatarData = {}): CancelablePromise<PostApiUserMeAvatarResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/me/avatar',
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: 'Nieprawidłowy plik lub przekroczony limit',
                401: 'Brak autoryzacji',
                500: 'Błąd serwera podczas wgrywania avatara'
            }
        });
    }
    
    /**
     * Pobierz użytkowników w domenie
     * Zwraca listę wszystkich użytkowników w domenie aktualnie zalogowanego użytkownika
     * @returns CurrentUserInfoDTO OK
     * @throws ApiError
     */
    public static getApiUserDomain(): CancelablePromise<GetApiUserDomainResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/domain'
        });
    }
    
}

export class TasksService {
    /**
     * Pobierz zadanie po ID
     * Zwraca szczegóły konkretnego zadania na podstawie jego identyfikatora
     * @param data The data for the request.
     * @param data.id Identyfikator zadania
     * @returns TaskDTO Zadanie zostało pomyślnie pobrane
     * @throws ApiError
     */
    public static getApiTasksById(data: GetApiTasksByIdData): CancelablePromise<GetApiTasksByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/{id}',
            path: {
                id: data.id
            },
            errors: {
                404: 'Zadanie o podanym ID nie zostało znalezione',
                500: 'Błąd serwera podczas pobierania zadania'
            }
        });
    }
    
    /**
     * Aktualizuj zadanie
     * Aktualizuje istniejące zadanie nowymi danymi
     * @param data The data for the request.
     * @param data.id Identyfikator zadania do aktualizacji
     * @param data.requestBody Zaktualizowane dane zadania
     * @returns TaskDTO Zadanie zostało pomyślnie zaktualizowane
     * @throws ApiError
     */
    public static putApiTasksById(data: PutApiTasksByIdData): CancelablePromise<PutApiTasksByIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/tasks/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Nieprawidłowe dane wejściowe - błędy walidacji',
                401: 'Brak autoryzacji',
                404: 'Zadanie o podanym ID nie zostało znalezione',
                500: 'Błąd serwera podczas aktualizacji zadania'
            }
        });
    }
    
    /**
     * Usuń zadanie
     * Usuwa zadanie z systemu na podstawie jego identyfikatora
     * @param data The data for the request.
     * @param data.id Identyfikator zadania do usunięcia
     * @returns void Zadanie zostało pomyślnie usunięte
     * @throws ApiError
     */
    public static deleteApiTasksById(data: DeleteApiTasksByIdData): CancelablePromise<DeleteApiTasksByIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/tasks/{id}',
            path: {
                id: data.id
            },
            errors: {
                404: 'Zadanie o podanym ID nie zostało znalezione',
                500: 'Błąd serwera podczas usuwania zadania'
            }
        });
    }
    
    /**
     * Usuń przypisanie zadania (ADMIN)
     * Usuwa przypisanie zadania od użytkownika
     * @param data The data for the request.
     * @param data.id Identyfikator zadania
     * @returns TaskDTO Przypisanie zadania zostało pomyślnie usunięte
     * @throws ApiError
     */
    public static putApiTasksByIdUnassign(data: PutApiTasksByIdUnassignData): CancelablePromise<PutApiTasksByIdUnassignResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/tasks/{id}/unassign',
            path: {
                id: data.id
            },
            errors: {
                403: 'Brak uprawnień administratora',
                404: 'Zadanie nie zostało znalezione',
                500: 'Błąd serwera podczas usuwania przypisania'
            }
        });
    }
    
    /**
     * Aktualizuj priorytet zadania
     * Aktualizuje priorytet konkretnego zadania
     * @param data The data for the request.
     * @param data.id Identyfikator zadania
     * @param data.priority Nowy priorytet zadania
     * @returns TaskDTO Priorytet zadania został pomyślnie zaktualizowany
     * @throws ApiError
     */
    public static putApiTasksByIdPriorityByPriority(data: PutApiTasksByIdPriorityByPriorityData): CancelablePromise<PutApiTasksByIdPriorityByPriorityResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/tasks/{id}/priority/{priority}',
            path: {
                id: data.id,
                priority: data.priority
            },
            errors: {
                400: 'Nieprawidłowa wartość priorytetu',
                404: 'Zadanie o podanym ID nie zostało znalezione',
                500: 'Błąd serwera podczas aktualizacji priorytetu'
            }
        });
    }
    
    /**
     * Przypisz zadanie do użytkownika (ADMIN)
     * Przypisuje zadanie do określonego użytkownika na podstawie jego Keycloak ID
     * @param data The data for the request.
     * @param data.id Identyfikator zadania
     * @param data.keycloakUserId Identyfikator użytkownika w Keycloak
     * @returns TaskDTO Zadanie zostało pomyślnie przypisane do użytkownika
     * @throws ApiError
     */
    public static putApiTasksByIdAssignByKeycloakUserId(data: PutApiTasksByIdAssignByKeycloakUserIdData): CancelablePromise<PutApiTasksByIdAssignByKeycloakUserIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/tasks/{id}/assign/{keycloakUserId}',
            path: {
                id: data.id,
                keycloakUserId: data.keycloakUserId
            },
            errors: {
                403: 'Brak uprawnień administratora',
                404: 'Zadanie lub użytkownik nie został znaleziony',
                500: 'Błąd serwera podczas przypisywania zadania'
            }
        });
    }
    
    /**
     * Pobierz wszystkie zadania
     * Zwraca listę wszystkich zadań w systemie
     * @returns TaskDTO Lista zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasks(): CancelablePromise<GetApiTasksResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks',
            errors: {
                500: 'Błąd serwera podczas pobierania zadań'
            }
        });
    }
    
    /**
     * Utwórz nowe zadanie
     * Tworzy nowe zadanie w systemie z danymi przekazanymi w żądaniu
     * @param data The data for the request.
     * @param data.requestBody Dane nowego zadania
     * @returns TaskDTO Zadanie zostało pomyślnie utworzone
     * @throws ApiError
     */
    public static postApiTasks(data: PostApiTasksData): CancelablePromise<PostApiTasksResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tasks',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Nieprawidłowe dane wejściowe - błędy walidacji',
                401: 'Brak autoryzacji',
                500: 'Błąd serwera podczas tworzenia zadania'
            }
        });
    }
    
    /**
     * Pobierz historię zmian zadania
     * Zwraca pełną historię zmian dla określonego zadania, posortowaną od najnowszych do najstarszych
     * @param data The data for the request.
     * @param data.taskId Identyfikator zadania
     * @returns TaskHistoryDTO Historia zadania została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksByTaskIdHistory(data: GetApiTasksByTaskIdHistoryData): CancelablePromise<GetApiTasksByTaskIdHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/{taskId}/history',
            path: {
                taskId: data.taskId
            },
            errors: {
                404: 'Zadanie o podanym ID nie istnieje',
                500: 'Błąd serwera podczas pobierania historii'
            }
        });
    }
    
    /**
     * Pobierz nieprzypisane zadania
     * Zwraca listę zadań które nie są przypisane do żadnego użytkownika
     * @returns TaskDTO Lista nieprzypisanych zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksUnassigned(): CancelablePromise<GetApiTasksUnassignedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/unassigned',
            errors: {
                500: 'Błąd serwera podczas pobierania zadań'
            }
        });
    }
    
    /**
     * Pobierz zadania po statusie
     * Zwraca listę zadań o określonym statusie
     * @param data The data for the request.
     * @param data.status Status zadań do wyszukania
     * @returns TaskDTO Lista zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksStatusByStatus(data: GetApiTasksStatusByStatusData): CancelablePromise<GetApiTasksStatusByStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/status/{status}',
            path: {
                status: data.status
            },
            errors: {
                400: 'Nieprawidłowa wartość statusu',
                500: 'Błąd serwera podczas pobierania zadań'
            }
        });
    }
    
    /**
     * Sprawdź czy użytkownik ma przypisane zadania (ADMIN)
     * Sprawdza czy określony użytkownik ma jakiekolwiek przypisane zadania
     * @param data The data for the request.
     * @param data.keycloakUserId Identyfikator użytkownika w Keycloak
     * @returns boolean Status został pomyślnie sprawdzony
     * @throws ApiError
     */
    public static getApiTasksStatsUserByKeycloakUserIdHasAssigned(data: GetApiTasksStatsUserByKeycloakUserIdHasAssignedData): CancelablePromise<GetApiTasksStatsUserByKeycloakUserIdHasAssignedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/stats/user/{keycloakUserId}/has-assigned',
            path: {
                keycloakUserId: data.keycloakUserId
            },
            errors: {
                403: 'Brak uprawnień administratora',
                500: 'Błąd serwera podczas sprawdzania statusu'
            }
        });
    }
    
    /**
     * Liczba zadań utworzonych przez użytkownika (ADMIN)
     * Zwraca liczbę zadań utworzonych przez określonego użytkownika
     * @param data The data for the request.
     * @param data.keycloakUserId Identyfikator użytkownika w Keycloak
     * @returns number Liczba zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksStatsUserByKeycloakUserIdCreatedCount(data: GetApiTasksStatsUserByKeycloakUserIdCreatedCountData): CancelablePromise<GetApiTasksStatsUserByKeycloakUserIdCreatedCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/stats/user/{keycloakUserId}/created-count',
            path: {
                keycloakUserId: data.keycloakUserId
            },
            errors: {
                403: 'Brak uprawnień administratora',
                500: 'Błąd serwera podczas pobierania statystyk'
            }
        });
    }
    
    /**
     * Liczba zadań przypisanych do użytkownika (ADMIN)
     * Zwraca liczbę zadań przypisanych do określonego użytkownika
     * @param data The data for the request.
     * @param data.keycloakUserId Identyfikator użytkownika w Keycloak
     * @returns number Liczba zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksStatsUserByKeycloakUserIdAssignedCount(data: GetApiTasksStatsUserByKeycloakUserIdAssignedCountData): CancelablePromise<GetApiTasksStatsUserByKeycloakUserIdAssignedCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/stats/user/{keycloakUserId}/assigned-count',
            path: {
                keycloakUserId: data.keycloakUserId
            },
            errors: {
                403: 'Brak uprawnień administratora',
                500: 'Błąd serwera podczas pobierania statystyk'
            }
        });
    }
    
    /**
     * Całkowita liczba zadań (ADMIN)
     * Zwraca całkowitą liczbę zadań w systemie
     * @returns number Całkowita liczba zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksStatsTotalCount(): CancelablePromise<GetApiTasksStatsTotalCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/stats/total-count',
            errors: {
                403: 'Brak uprawnień administratora',
                500: 'Błąd serwera podczas pobierania statystyk'
            }
        });
    }
    
    /**
     * Liczba zadań według statusu (ADMIN)
     * Zwraca liczbę zadań o określonym statusie
     * @param data The data for the request.
     * @param data.status Status zadań do zliczenia
     * @returns number Liczba zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksStatsStatusByStatusCount(data: GetApiTasksStatsStatusByStatusCountData): CancelablePromise<GetApiTasksStatsStatusByStatusCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/stats/status/{status}/count',
            path: {
                status: data.status
            },
            errors: {
                400: 'Nieprawidłowa wartość statusu',
                403: 'Brak uprawnień administratora',
                500: 'Błąd serwera podczas pobierania statystyk'
            }
        });
    }
    
    /**
     * Liczba zadań według priorytetu (ADMIN)
     * Zwraca liczbę zadań o określonym priorytecie
     * @param data The data for the request.
     * @param data.priority Priorytet zadań do zliczenia
     * @returns number Liczba zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksStatsPriorityByPriorityCount(data: GetApiTasksStatsPriorityByPriorityCountData): CancelablePromise<GetApiTasksStatsPriorityByPriorityCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/stats/priority/{priority}/count',
            path: {
                priority: data.priority
            },
            errors: {
                400: 'Nieprawidłowa wartość priorytetu',
                403: 'Brak uprawnień administratora',
                500: 'Błąd serwera podczas pobierania statystyk'
            }
        });
    }
    
    /**
     * Sprawdź czy aktualnie zalogowany użytkownik ma przypisane zadania
     * @returns boolean OK
     * @throws ApiError
     */
    public static getApiTasksStatsMyHasAssigned(): CancelablePromise<GetApiTasksStatsMyHasAssignedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/stats/my/has-assigned'
        });
    }
    
    /**
     * Liczba zadań utworzonych przez aktualnie zalogowanego użytkownika
     * @returns number OK
     * @throws ApiError
     */
    public static getApiTasksStatsMyCreatedCount(): CancelablePromise<GetApiTasksStatsMyCreatedCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/stats/my/created-count'
        });
    }
    
    /**
     * Liczba zadań przypisanych do aktualnie zalogowanego użytkownika
     * @returns number OK
     * @throws ApiError
     */
    public static getApiTasksStatsMyAssignedCount(): CancelablePromise<GetApiTasksStatsMyAssignedCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/stats/my/assigned-count'
        });
    }
    
    /**
     * Pobiera kompleksowe statystyki zadań
     * Zwraca obiekt zawierający liczbę zadań w każdym statusie, liczbę zadań przeterminowanych, liczbę zadań należących do aktualnie zalogowanego użytkownika oraz całkowitą liczbę zadań w systemie
     * @returns TaskStatisticsDTO Statystyki zostały pomyślnie pobrane
     * @throws ApiError
     */
    public static getApiTasksStatsComprehensive(): CancelablePromise<GetApiTasksStatsComprehensiveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/stats/comprehensive',
            errors: {
                500: 'Błąd serwera podczas pobierania statystyk'
            }
        });
    }
    
    /**
     * Pobierz zadania w przedziale dat rozpoczęcia
     * Zwraca listę zadań których data rozpoczęcia mieści się w podanym przedziale
     * @param data The data for the request.
     * @param data.start Data początkowa (format ISO: yyyy-MM-ddTHH:mm:ss)
     * @param data.end Data końcowa (format ISO: yyyy-MM-ddTHH:mm:ss)
     * @returns TaskDTO Lista zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksStartDateBetween(data: GetApiTasksStartDateBetweenData): CancelablePromise<GetApiTasksStartDateBetweenResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/startDate/between',
            query: {
                start: data.start,
                end: data.end
            },
            errors: {
                400: 'Nieprawidłowy format daty lub nieprawidłowy przedział',
                500: 'Błąd serwera podczas pobierania zadań'
            }
        });
    }
    
    /**
     * Pobierz ostatnio utworzone zadania
     * Zwraca listę zadań utworzonych po podanej dacie
     * @param data The data for the request.
     * @param data.since Data od której szukać zadań (format ISO: yyyy-MM-ddTHH:mm:ss)
     * @returns TaskDTO Lista ostatnio utworzonych zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksRecent(data: GetApiTasksRecentData): CancelablePromise<GetApiTasksRecentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/recent',
            query: {
                since: data.since
            },
            errors: {
                400: 'Nieprawidłowy format daty',
                500: 'Błąd serwera podczas pobierania zadań'
            }
        });
    }
    
    /**
     * Pobierz zadania po priorytecie
     * Zwraca listę zadań o określonym priorytecie
     * @param data The data for the request.
     * @param data.priority Priorytet zadań do wyszukania
     * @returns TaskDTO Lista zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksPriorityByPriority(data: GetApiTasksPriorityByPriorityData): CancelablePromise<GetApiTasksPriorityByPriorityResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/priority/{priority}',
            path: {
                priority: data.priority
            },
            errors: {
                400: 'Nieprawidłowa wartość priorytetu',
                500: 'Błąd serwera podczas pobierania zadań'
            }
        });
    }
    
    /**
     * Pobierz zadania z zaawansowanym filtrowaniem i paginacją
     * Zwraca paginowaną listę zadań z możliwością filtrowania, sortowania i różnych widoków
     * @param data The data for the request.
     * @param data.page
     * @param data.size
     * @param data.titleOrDescription
     * @param data.clientId
     * @param data.assignedToUserId
     * @param data.taskType
     * @param data.priority
     * @param data.deadlineFrom
     * @param data.deadlineTo
     * @param data.createdFrom
     * @param data.createdTo
     * @param data.view
     * @param data.sortBy
     * @param data.sortDirection
     * @returns TaskPagedResponse OK
     * @throws ApiError
     */
    public static getApiTasksPaginated(data: GetApiTasksPaginatedData = {}): CancelablePromise<GetApiTasksPaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/paginated',
            query: {
                page: data.page,
                size: data.size,
                titleOrDescription: data.titleOrDescription,
                clientId: data.clientId,
                assignedToUserId: data.assignedToUserId,
                taskType: data.taskType,
                priority: data.priority,
                deadlineFrom: data.deadlineFrom,
                deadlineTo: data.deadlineTo,
                createdFrom: data.createdFrom,
                createdTo: data.createdTo,
                view: data.view,
                sortBy: data.sortBy,
                sortDirection: data.sortDirection
            }
        });
    }
    
    /**
     * Pobierz przeterminowane zadania
     * Zwraca listę zadań których data zakończenia już minęła
     * @returns TaskDTO Lista przeterminowanych zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksOverdue(): CancelablePromise<GetApiTasksOverdueResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/overdue',
            errors: {
                500: 'Błąd serwera podczas pobierania zadań'
            }
        });
    }
    
    /**
     * Pobiera zadania utworzone przez aktualnie zalogowanego użytkownika
     * @returns TaskDTO OK
     * @throws ApiError
     */
    public static getApiTasksMyCreated(): CancelablePromise<GetApiTasksMyCreatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/my/created'
        });
    }
    
    /**
     * Pobiera zadania przypisane do aktualnie zalogowanego użytkownika
     * @returns TaskDTO OK
     * @throws ApiError
     */
    public static getApiTasksMyAssigned(): CancelablePromise<GetApiTasksMyAssignedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/my/assigned'
        });
    }
    
    /**
     * Pobiera zadania przypisane do aktualnie zalogowanego użytkownika o określonym statusie
     * @param data The data for the request.
     * @param data.status
     * @returns TaskDTO OK
     * @throws ApiError
     */
    public static getApiTasksMyAssignedStatusByStatus(data: GetApiTasksMyAssignedStatusByStatusData): CancelablePromise<GetApiTasksMyAssignedStatusByStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/my/assigned/status/{status}',
            path: {
                status: data.status
            }
        });
    }
    
    /**
     * Pobiera przeterminowane zadania aktualnie zalogowanego użytkownika
     * @returns TaskDTO OK
     * @throws ApiError
     */
    public static getApiTasksMyAssignedOverdue(): CancelablePromise<GetApiTasksMyAssignedOverdueResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/my/assigned/overdue'
        });
    }
    
    /**
     * Pobierz zadania w przedziale dat zakończenia
     * Zwraca listę zadań których data zakończenia mieści się w podanym przedziale
     * @param data The data for the request.
     * @param data.start Data początkowa (format ISO: yyyy-MM-ddTHH:mm:ss)
     * @param data.end Data końcowa (format ISO: yyyy-MM-ddTHH:mm:ss)
     * @returns TaskDTO Lista zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksEndDateBetween(data: GetApiTasksEndDateBetweenData): CancelablePromise<GetApiTasksEndDateBetweenResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/endDate/between',
            query: {
                start: data.start,
                end: data.end
            },
            errors: {
                400: 'Nieprawidłowy format daty lub nieprawidłowy przedział',
                500: 'Błąd serwera podczas pobierania zadań'
            }
        });
    }
    
    /**
     * Pobierz zadania w przedziale dat utworzenia
     * Zwraca listę zadań których data utworzenia mieści się w podanym przedziale
     * @param data The data for the request.
     * @param data.start Data początkowa (format ISO: yyyy-MM-ddTHH:mm:ss)
     * @param data.end Data końcowa (format ISO: yyyy-MM-ddTHH:mm:ss)
     * @returns TaskDTO Lista zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksCreatedAtBetween(data: GetApiTasksCreatedAtBetweenData): CancelablePromise<GetApiTasksCreatedAtBetweenResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/createdAt/between',
            query: {
                start: data.start,
                end: data.end
            },
            errors: {
                400: 'Nieprawidłowy format daty lub nieprawidłowy przedział',
                500: 'Błąd serwera podczas pobierania zadań'
            }
        });
    }
    
    /**
     * Pobierz zadania utworzone przez użytkownika (ADMIN)
     * Zwraca listę zadań utworzonych przez określonego użytkownika
     * @param data The data for the request.
     * @param data.keycloakUserId Identyfikator użytkownika w Keycloak
     * @returns TaskDTO Lista zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksCreatedByByKeycloakUserId(data: GetApiTasksCreatedByByKeycloakUserIdData): CancelablePromise<GetApiTasksCreatedByByKeycloakUserIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/created-by/{keycloakUserId}',
            path: {
                keycloakUserId: data.keycloakUserId
            },
            errors: {
                403: 'Brak uprawnień administratora',
                500: 'Błąd serwera podczas pobierania zadań'
            }
        });
    }
    
    /**
     * Pobierz zadania przypisane do użytkownika (ADMIN)
     * Zwraca listę zadań przypisanych do określonego użytkownika
     * @param data The data for the request.
     * @param data.keycloakUserId Identyfikator użytkownika w Keycloak
     * @returns TaskDTO Lista zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksAssignedToByKeycloakUserId(data: GetApiTasksAssignedToByKeycloakUserIdData): CancelablePromise<GetApiTasksAssignedToByKeycloakUserIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/assigned-to/{keycloakUserId}',
            path: {
                keycloakUserId: data.keycloakUserId
            },
            errors: {
                403: 'Brak uprawnień administratora',
                500: 'Błąd serwera podczas pobierania zadań'
            }
        });
    }
    
    /**
     * Pobierz zadania przypisane do użytkownika o określonym statusie (ADMIN)
     * Zwraca listę zadań przypisanych do użytkownika z określonym statusem
     * @param data The data for the request.
     * @param data.keycloakUserId Identyfikator użytkownika w Keycloak
     * @param data.status Status zadań do wyszukania
     * @returns TaskDTO Lista zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksAssignedToByKeycloakUserIdStatusByStatus(data: GetApiTasksAssignedToByKeycloakUserIdStatusByStatusData): CancelablePromise<GetApiTasksAssignedToByKeycloakUserIdStatusByStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/assigned-to/{keycloakUserId}/status/{status}',
            path: {
                keycloakUserId: data.keycloakUserId,
                status: data.status
            },
            errors: {
                400: 'Nieprawidłowa wartość statusu',
                403: 'Brak uprawnień administratora',
                500: 'Błąd serwera podczas pobierania zadań'
            }
        });
    }
    
    /**
     * Pobierz przeterminowane zadania użytkownika (ADMIN)
     * Zwraca listę przeterminowanych zadań przypisanych do określonego użytkownika
     * @param data The data for the request.
     * @param data.keycloakUserId Identyfikator użytkownika w Keycloak
     * @returns TaskDTO Lista przeterminowanych zadań została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiTasksAssignedToByKeycloakUserIdOverdue(data: GetApiTasksAssignedToByKeycloakUserIdOverdueData): CancelablePromise<GetApiTasksAssignedToByKeycloakUserIdOverdueResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/assigned-to/{keycloakUserId}/overdue',
            path: {
                keycloakUserId: data.keycloakUserId
            },
            errors: {
                403: 'Brak uprawnień administratora',
                500: 'Błąd serwera podczas pobierania zadań'
            }
        });
    }
    
}

export class LeadAttributesService {
    /**
     * Pobierz predefiniowany atrybut po ID
     * Zwraca szczegóły predefiniowanego atrybutu o podanym identyfikatorze
     * @param data The data for the request.
     * @param data.id Identyfikator predefiniowanego atrybutu
     * @returns PredefinedLeadAttributeDTO Predefiniowany atrybut został pomyślnie znaleziony
     * @throws ApiError
     */
    public static getApiPredefinedLeadAttributesById(data: GetApiPredefinedLeadAttributesByIdData): CancelablePromise<GetApiPredefinedLeadAttributesByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/predefined-lead-attributes/{id}',
            path: {
                id: data.id
            },
            errors: {
                404: 'Predefiniowany atrybut o podanym ID nie został znaleziony'
            }
        });
    }
    
    /**
     * Aktualizuj predefiniowany atrybut
     * Aktualizuje istniejący predefiniowany atrybut w domenie użytkownika
     * @param data The data for the request.
     * @param data.id Identyfikator predefiniowanego atrybutu
     * @param data.requestBody
     * @returns PredefinedLeadAttributeDTO Predefiniowany atrybut został pomyślnie zaktualizowany
     * @throws ApiError
     */
    public static putApiPredefinedLeadAttributesById(data: PutApiPredefinedLeadAttributesByIdData): CancelablePromise<PutApiPredefinedLeadAttributesByIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/predefined-lead-attributes/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Nieprawidłowe dane wejściowe',
                403: 'Brak dostępu do atrybutu w innej domenie',
                404: 'Predefiniowany atrybut o podanym ID nie został znaleziony'
            }
        });
    }
    
    /**
     * Usuń predefiniowany atrybut
     * Usuwa predefiniowany atrybut o podanym identyfikatorze w domenie użytkownika
     * @param data The data for the request.
     * @param data.id Identyfikator predefiniowanego atrybutu
     * @returns void Predefiniowany atrybut został pomyślnie usunięty
     * @throws ApiError
     */
    public static deleteApiPredefinedLeadAttributesById(data: DeleteApiPredefinedLeadAttributesByIdData): CancelablePromise<DeleteApiPredefinedLeadAttributesByIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/predefined-lead-attributes/{id}',
            path: {
                id: data.id
            },
            errors: {
                403: 'Brak dostępu do atrybutu w innej domenie',
                404: 'Predefiniowany atrybut o podanym ID nie został znaleziony'
            }
        });
    }
    
    /**
     * Pobierz wszystkie predefiniowane atrybuty
     * Zwraca listę wszystkich predefiniowanych atrybutów dla leadów w domenie użytkownika
     * @returns PredefinedLeadAttributeDTO Lista predefiniowanych atrybutów została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiPredefinedLeadAttributes(): CancelablePromise<GetApiPredefinedLeadAttributesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/predefined-lead-attributes'
        });
    }
    
    /**
     * Utwórz nowy predefiniowany atrybut
     * Tworzy nowy predefiniowany atrybut dla leadów w domenie użytkownika
     * @param data The data for the request.
     * @param data.requestBody
     * @returns PredefinedLeadAttributeDTO Predefiniowany atrybut został pomyślnie utworzony
     * @throws ApiError
     */
    public static postApiPredefinedLeadAttributes(data: PostApiPredefinedLeadAttributesData): CancelablePromise<PostApiPredefinedLeadAttributesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/predefined-lead-attributes',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Nieprawidłowe dane wejściowe'
            }
        });
    }
    
    /**
     * Pobierz predefiniowane atrybuty dla domeny użytkownika
     * Zwraca listę predefiniowanych atrybutów dla kontaktów w domenie użytkownika
     * @returns PredefinedLeadAttributeDTO Lista predefiniowanych atrybutów została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiLeadContactsPredefinedAttributes(): CancelablePromise<GetApiLeadContactsPredefinedAttributesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-contacts/predefined-attributes'
        });
    }
    
}

export class OffersService {
    /**
     * Pobierz ofertę po ID
     * @param data The data for the request.
     * @param data.id
     * @returns OfferDTO OK
     * @throws ApiError
     */
    public static getApiOffersById(data: GetApiOffersByIdData): CancelablePromise<GetApiOffersByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/offers/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Aktualizuj ofertę
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns OfferDTO OK
     * @throws ApiError
     */
    public static putApiOffersById(data: PutApiOffersByIdData): CancelablePromise<PutApiOffersByIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/offers/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Usuń ofertę
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public static deleteApiOffersById(data: DeleteApiOffersByIdData): CancelablePromise<DeleteApiOffersByIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/offers/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Pobierz wszystkie oferty
     * @returns OfferDTO OK
     * @throws ApiError
     */
    public static getApiOffers(): CancelablePromise<GetApiOffersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/offers'
        });
    }
    
    /**
     * Utwórz nową ofertę
     * @param data The data for the request.
     * @param data.requestBody
     * @returns OfferDTO Created
     * @throws ApiError
     */
    public static postApiOffers(data: PostApiOffersData): CancelablePromise<PostApiOffersResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/offers',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Pobierz oferty po typie
     * @param data The data for the request.
     * @param data.type
     * @returns OfferDTO OK
     * @throws ApiError
     */
    public static getApiOffersTypeByType(data: GetApiOffersTypeByTypeData): CancelablePromise<GetApiOffersTypeByTypeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/offers/type/{type}',
            path: {
                type: data.type
            }
        });
    }
    
    /**
     * Wyszukaj oferty po nazwie
     * @param data The data for the request.
     * @param data.name
     * @returns OfferDTO OK
     * @throws ApiError
     */
    public static getApiOffersSearch(data: GetApiOffersSearchData): CancelablePromise<GetApiOffersSearchResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/offers/search',
            query: {
                name: data.name
            }
        });
    }
    
}

export class LeadCrudService {
    /**
     * Pobierz kontakt po ID
     * Zwraca szczegóły kontaktu o podanym identyfikatorze
     * @param data The data for the request.
     * @param data.id Identyfikator kontaktu
     * @returns LeadDTO Kontakt został pomyślnie znaleziony
     * @throws ApiError
     */
    public static getApiLeadContactsById(data: GetApiLeadContactsByIdData): CancelablePromise<GetApiLeadContactsByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-contacts/{id}',
            path: {
                id: data.id
            },
            errors: {
                404: 'Kontakt o podanym ID nie został znaleziony'
            }
        });
    }
    
    /**
     * Aktualizuj kontakt
     * Aktualizuje istniejący kontakt
     * @param data The data for the request.
     * @param data.id Identyfikator kontaktu
     * @param data.requestBody
     * @returns LeadDTO Kontakt został pomyślnie zaktualizowany
     * @throws ApiError
     */
    public static putApiLeadContactsById(data: PutApiLeadContactsByIdData): CancelablePromise<PutApiLeadContactsByIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/lead-contacts/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Nieprawidłowe dane wejściowe',
                404: 'Kontakt o podanym ID nie został znaleziony'
            }
        });
    }
    
    /**
     * Usuń kontakt
     * Usuwa kontakt o podanym identyfikatorze
     * @param data The data for the request.
     * @param data.id Identyfikator kontaktu
     * @returns void Kontakt został pomyślnie usunięty
     * @throws ApiError
     */
    public static deleteApiLeadContactsById(data: DeleteApiLeadContactsByIdData): CancelablePromise<DeleteApiLeadContactsByIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/lead-contacts/{id}',
            path: {
                id: data.id
            },
            errors: {
                404: 'Kontakt o podanym ID nie został znaleziony'
            }
        });
    }
    
    /**
     * Pobierz wszystkie kontakty
     * Zwraca listę wszystkich kontaktów typu lead
     * @returns LeadDTO Lista kontaktów została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiLeadContacts(): CancelablePromise<GetApiLeadContactsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-contacts'
        });
    }
    
    /**
     * Utwórz nowy kontakt
     * Tworzy nowy kontakt typu lead
     * @param data The data for the request.
     * @param data.requestBody
     * @returns LeadDTO Kontakt został pomyślnie utworzony
     * @throws ApiError
     */
    public static postApiLeadContacts(data: PostApiLeadContactsData): CancelablePromise<PostApiLeadContactsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/lead-contacts',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Nieprawidłowe dane wejściowe'
            }
        });
    }
    
    /**
     * Pobierz kontakty z zaawansowanym filtrowaniem i paginacją
     * Zwraca paginowaną listę kontaktów z możliwością filtrowania i sortowania
     * @param data The data for the request.
     * @param data.page
     * @param data.size
     * @param data.searchTerm
     * @param data.acquisitionTypeId
     * @param data.offer
     * @param data.createdFrom
     * @param data.createdTo
     * @param data.sortBy
     * @param data.sortDirection
     * @returns LeadPagedResponse Paginowana lista kontaktów została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiLeadContactsPaginated(data: GetApiLeadContactsPaginatedData = {}): CancelablePromise<GetApiLeadContactsPaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-contacts/paginated',
            query: {
                page: data.page,
                size: data.size,
                searchTerm: data.searchTerm,
                acquisitionTypeId: data.acquisitionTypeId,
                offer: data.offer,
                createdFrom: data.createdFrom,
                createdTo: data.createdTo,
                sortBy: data.sortBy,
                sortDirection: data.sortDirection
            }
        });
    }
    
}

export class KanbanService {
    /**
     * Zmień status zadania
     * Zmienia status zadania bez pozycjonowania
     * @param data The data for the request.
     * @param data.taskId Identyfikator zadania
     * @param data.requestBody Nowy status zadania
     * @returns unknown Status zadania został pomyślnie zaktualizowany
     * @throws ApiError
     */
    public static putApiKanbanTasksByTaskIdStatus(data: PutApiKanbanTasksByTaskIdStatusData): CancelablePromise<PutApiKanbanTasksByTaskIdStatusResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/kanban/tasks/{taskId}/status',
            path: {
                taskId: data.taskId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Nieprawidłowe dane wejściowe - błędy walidacji',
                404: 'Zadanie o podanym ID nie zostało znalezione',
                500: 'Błąd serwera podczas aktualizacji statusu'
            }
        });
    }
    
    /**
     * Pobierz dane dla tablicy kanban
     * Zwraca zadania dla tablicy kanban z filtrowaniem po zakresie dat i opcjonalnie po użytkownikach
     * @param data The data for the request.
     * @param data.startDate Data początkowa zakresu (format: yyyy-MM-ddTHH:mm:ss)
     * @param data.endDate Data końcowa zakresu (format: yyyy-MM-ddTHH:mm:ss)
     * @param data.userIds Lista ID użytkowników do filtrowania (opcjonalne)
     * @returns TaskWithKanbanInfoDTO Dane tablicy kanban zostały pomyślnie pobrane
     * @throws ApiError
     */
    public static getApiKanbanBoard(data: GetApiKanbanBoardData): CancelablePromise<GetApiKanbanBoardResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/kanban/board',
            query: {
                startDate: data.startDate,
                endDate: data.endDate,
                userIds: data.userIds
            },
            errors: {
                400: 'Nieprawidłowe parametry daty',
                500: 'Błąd serwera podczas pobierania danych tablicy kanban'
            }
        });
    }
    
    /**
     * Pobierz zadania kanban dla konkretnego statusu
     * @param data The data for the request.
     * @param data.status Status zadań do wyszukania
     * @returns TaskWithKanbanInfoDTO Zadania kanban dla statusu zostały pomyślnie pobrane
     * @throws ApiError
     */
    public static getApiKanbanBoardStatusByStatus(data: GetApiKanbanBoardStatusByStatusData): CancelablePromise<GetApiKanbanBoardStatusByStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/kanban/board/status/{status}',
            path: {
                status: data.status
            },
            errors: {
                400: 'Nieprawidłowa wartość statusu',
                500: 'Błąd serwera podczas pobierania zadań kanban'
            }
        });
    }
    
}

export class PrefixConfigControllerService {
    /**
     * Pobierz wartość prefiksu
     * Zwraca wartość prefiksu dla danego typu
     * @param data The data for the request.
     * @param data.prefixType
     * @returns string Wartość prefiksu została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiConfigPrefixByPrefixType(data: GetApiConfigPrefixByPrefixTypeData): CancelablePromise<GetApiConfigPrefixByPrefixTypeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/config/prefix/{prefixType}',
            path: {
                prefixType: data.prefixType
            }
        });
    }
    
    /**
     * Aktualizuj wartość prefiksu
     * Aktualizuje wartość prefiksu dla danego typu
     * @param data The data for the request.
     * @param data.prefixType
     * @param data.requestBody
     * @returns PrefixConfiguration Wartość prefiksu została pomyślnie zaktualizowana
     * @throws ApiError
     */
    public static putApiConfigPrefixByPrefixType(data: PutApiConfigPrefixByPrefixTypeData): CancelablePromise<PutApiConfigPrefixByPrefixTypeResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/config/prefix/{prefixType}',
            path: {
                prefixType: data.prefixType
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Pobierz konfigurację prefiksów
     * Zwraca aktualną konfigurację prefiksów dla zadań i leadów
     * @returns PrefixConfigDTO Konfiguracja prefiksów została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiConfigPrefix(): CancelablePromise<GetApiConfigPrefixResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/config/prefix'
        });
    }
    
    /**
     * Pobierz wszystkie konfiguracje prefiksów
     * Zwraca wszystkie dostępne konfiguracje prefiksów
     * @returns PrefixConfiguration Lista konfiguracji prefiksów została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiConfigPrefixAll(): CancelablePromise<GetApiConfigPrefixAllResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/config/prefix/all'
        });
    }
    
}

export class CommentsService {
    /**
     * Pobierz komentarz po ID
     * @param data The data for the request.
     * @param data.id
     * @returns CommentDTO OK
     * @throws ApiError
     */
    public static getApiCommentsById(data: GetApiCommentsByIdData): CancelablePromise<GetApiCommentsByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/comments/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Zaktualizuj istniejący komentarz
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns CommentDTO OK
     * @throws ApiError
     */
    public static putApiCommentsById(data: PutApiCommentsByIdData): CancelablePromise<PutApiCommentsByIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/comments/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Usuń komentarz
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public static deleteApiCommentsById(data: DeleteApiCommentsByIdData): CancelablePromise<DeleteApiCommentsByIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/comments/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Pobierz komentarze dla określonego obiektu
     * @param data The data for the request.
     * @param data.objectId
     * @param data.objectType
     * @returns CommentDTO OK
     * @throws ApiError
     */
    public static getApiComments(data: GetApiCommentsData): CancelablePromise<GetApiCommentsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/comments',
            query: {
                objectId: data.objectId,
                objectType: data.objectType
            }
        });
    }
    
    /**
     * Utwórz nowy komentarz z obsługą wzmiankowania
     * @param data The data for the request.
     * @param data.requestBody
     * @returns CommentDTO Created
     * @throws ApiError
     */
    public static postApiComments(data: PostApiCommentsData): CancelablePromise<PostApiCommentsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/comments',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Policz komentarze użytkownika (ADMIN)
     * @param data The data for the request.
     * @param data.userId
     * @returns number OK
     * @throws ApiError
     */
    public static getApiCommentsUserByUserIdCount(data: GetApiCommentsUserByUserIdCountData): CancelablePromise<GetApiCommentsUserByUserIdCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/comments/user/{userId}/count',
            path: {
                userId: data.userId
            }
        });
    }
    
    /**
     * Pobierz wszystkie komentarze aktualnie zalogowanego użytkownika
     * Zwraca wszystkie komentarze utworzone przez aktualnie zalogowanego użytkownika.
     * Komentarze są sortowane od najnowszych do najstarszych.
     *
     * @returns CommentDTO Lista komentarzy użytkownika
     * @throws ApiError
     */
    public static getApiCommentsMy(): CancelablePromise<GetApiCommentsMyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/comments/my',
            errors: {
                401: 'Brak autoryzacji'
            }
        });
    }
    
    /**
     * Policz komentarze aktualnego użytkownika
     * Zwraca liczbę komentarzy utworzonych przez aktualnie zalogowanego użytkownika
     * @returns unknown Liczba komentarzy użytkownika
     * @throws ApiError
     */
    public static getApiCommentsMyCount(): CancelablePromise<GetApiCommentsMyCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/comments/my/count'
        });
    }
    
    /**
     * Pobierz komentarze gdzie użytkownik został wzmiankowany
     * Zwraca wszystkie komentarze gdzie określony użytkownik został wzmiankowany.
     * Komentarze są sortowane od najnowszych.
     *
     * @param data The data for the request.
     * @param data.userId ID użytkownika Keycloak
     * @returns CommentDTO Lista komentarzy z wzmiankami
     * @throws ApiError
     */
    public static getApiCommentsMentionsUserByUserId(data: GetApiCommentsMentionsUserByUserIdData): CancelablePromise<GetApiCommentsMentionsUserByUserIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/comments/mentions/user/{userId}',
            path: {
                userId: data.userId
            },
            errors: {
                404: 'Nie znaleziono użytkownika'
            }
        });
    }
    
    /**
     * Sprawdź czy użytkownik ma wzmianki (ADMIN)
     * @param data The data for the request.
     * @param data.userId
     * @returns boolean OK
     * @throws ApiError
     */
    public static getApiCommentsMentionsUserByUserIdExists(data: GetApiCommentsMentionsUserByUserIdExistsData): CancelablePromise<GetApiCommentsMentionsUserByUserIdExistsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/comments/mentions/user/{userId}/exists',
            path: {
                userId: data.userId
            }
        });
    }
    
    /**
     * Policz wzmianki użytkownika (ADMIN)
     * @param data The data for the request.
     * @param data.userId
     * @returns number OK
     * @throws ApiError
     */
    public static getApiCommentsMentionsUserByUserIdCount(data: GetApiCommentsMentionsUserByUserIdCountData): CancelablePromise<GetApiCommentsMentionsUserByUserIdCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/comments/mentions/user/{userId}/count',
            path: {
                userId: data.userId
            }
        });
    }
    
    /**
     * Pobierz komentarze z wzmiankami dla określonego obiektu
     * Zwraca komentarze zawierające wzmianki użytkowników dla określonego obiektu
     * @param data The data for the request.
     * @param data.objectId ID obiektu
     * @param data.objectType Typ obiektu
     * @returns CommentDTO OK
     * @throws ApiError
     */
    public static getApiCommentsMentionsObjectByObjectId(data: GetApiCommentsMentionsObjectByObjectIdData): CancelablePromise<GetApiCommentsMentionsObjectByObjectIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/comments/mentions/object/{objectId}',
            path: {
                objectId: data.objectId
            },
            query: {
                objectType: data.objectType
            }
        });
    }
    
    /**
     * Policz wzmianki dla obiektu
     * Zwraca liczbę komentarzy z wzmiankami dla określonego obiektu
     * @param data The data for the request.
     * @param data.objectId ID obiektu
     * @param data.objectType Typ obiektu
     * @returns number OK
     * @throws ApiError
     */
    public static getApiCommentsMentionsObjectByObjectIdCount(data: GetApiCommentsMentionsObjectByObjectIdCountData): CancelablePromise<GetApiCommentsMentionsObjectByObjectIdCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/comments/mentions/object/{objectId}/count',
            path: {
                objectId: data.objectId
            },
            query: {
                objectType: data.objectType
            }
        });
    }
    
    /**
     * Pobierz komentarze gdzie aktualny użytkownik został wzmiankowany
     * Zwraca wszystkie komentarze gdzie aktualnie zalogowany użytkownik został wzmiankowany.
     * Komentarze są sortowane od najnowszych.
     *
     * @returns CommentDTO Lista komentarzy z wzmiankami
     * @throws ApiError
     */
    public static getApiCommentsMentionsMy(): CancelablePromise<GetApiCommentsMentionsMyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/comments/mentions/my',
            errors: {
                401: 'Brak autoryzacji'
            }
        });
    }
    
    /**
     * Sprawdź czy aktualny użytkownik ma wzmianki
     * Sprawdza czy aktualnie zalogowany użytkownik ma jakiekolwiek wzmianki w komentarzach
     * @returns boolean OK
     * @throws ApiError
     */
    public static getApiCommentsMentionsMyExists(): CancelablePromise<GetApiCommentsMentionsMyExistsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/comments/mentions/my/exists'
        });
    }
    
    /**
     * Policz wzmianki aktualnego użytkownika
     * Zwraca liczbę komentarzy gdzie aktualnie zalogowany użytkownik został wzmiankowany
     * @returns unknown Liczba wzmiankowanych komentarzy
     * @throws ApiError
     */
    public static getApiCommentsMentionsMyCount(): CancelablePromise<GetApiCommentsMentionsMyCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/comments/mentions/my/count'
        });
    }
    
    /**
     * Pobierz wszystkie komentarze z wzmiankami
     * Zwraca wszystkie komentarze w systemie które zawierają wzmianki użytkowników
     * @returns CommentDTO OK
     * @throws ApiError
     */
    public static getApiCommentsMentionsAll(): CancelablePromise<GetApiCommentsMentionsAllResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/comments/mentions/all'
        });
    }
    
    /**
     * Pobierz wszystkie komentarze w systemie (ADMIN)
     * @returns CommentDTO OK
     * @throws ApiError
     */
    public static getApiCommentsAll(): CancelablePromise<GetApiCommentsAllResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/comments/all'
        });
    }
    
}

export class AttributesService {
    /**
     * Pobierz atrybut po ID
     * @param data The data for the request.
     * @param data.id
     * @returns AttributeDTO OK
     * @throws ApiError
     */
    public static getApiAttributesById(data: GetApiAttributesByIdData): CancelablePromise<GetApiAttributesByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/attributes/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Zaktualizuj istniejący atrybut
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns AttributeDTO OK
     * @throws ApiError
     */
    public static putApiAttributesById(data: PutApiAttributesByIdData): CancelablePromise<PutApiAttributesByIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/attributes/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Usuń atrybut
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public static deleteApiAttributesById(data: DeleteApiAttributesByIdData): CancelablePromise<DeleteApiAttributesByIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/attributes/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Zaktualizuj wiele atrybutów jednocześnie
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AttributeDTO OK
     * @throws ApiError
     */
    public static putApiAttributesBulk(data: PutApiAttributesBulkData): CancelablePromise<PutApiAttributesBulkResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/attributes/bulk',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Utwórz wiele atrybutów jednocześnie
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AttributeDTO Created
     * @throws ApiError
     */
    public static postApiAttributesBulk(data: PostApiAttributesBulkData): CancelablePromise<PostApiAttributesBulkResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/attributes/bulk',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Pobierz wszystkie atrybuty
     * @returns AttributeDTO OK
     * @throws ApiError
     */
    public static getApiAttributes(): CancelablePromise<GetApiAttributesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/attributes'
        });
    }
    
    /**
     * Utwórz nowy atrybut
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AttributeDTO Created
     * @throws ApiError
     */
    public static postApiAttributes(data: PostApiAttributesData): CancelablePromise<PostApiAttributesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/attributes',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Pobierz atrybuty dla określonego obiektu
     * @param data The data for the request.
     * @param data.objectType
     * @param data.objectId
     * @returns AttributeDTO OK
     * @throws ApiError
     */
    public static getApiAttributesObjectByObjectTypeByObjectId(data: GetApiAttributesObjectByObjectTypeByObjectIdData): CancelablePromise<GetApiAttributesObjectByObjectTypeByObjectIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/attributes/object/{objectType}/{objectId}',
            path: {
                objectType: data.objectType,
                objectId: data.objectId
            }
        });
    }
    
    /**
     * Usuń wszystkie atrybuty dla określonego obiektu
     * @param data The data for the request.
     * @param data.objectType
     * @param data.objectId
     * @returns void No Content
     * @throws ApiError
     */
    public static deleteApiAttributesObjectByObjectTypeByObjectId(data: DeleteApiAttributesObjectByObjectTypeByObjectIdData): CancelablePromise<DeleteApiAttributesObjectByObjectTypeByObjectIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/attributes/object/{objectType}/{objectId}',
            path: {
                objectType: data.objectType,
                objectId: data.objectId
            }
        });
    }
    
}

export class AcquisitionTypesService {
    /**
     * Aktualizuj typ pozyskania
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns AcquisitionTypeDTO OK
     * @throws ApiError
     */
    public static putAcquisitionTypesById(data: PutAcquisitionTypesByIdData): CancelablePromise<PutAcquisitionTypesByIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/acquisition-types/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Usuń typ pozyskania
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public static deleteAcquisitionTypesById(data: DeleteAcquisitionTypesByIdData): CancelablePromise<DeleteAcquisitionTypesByIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/acquisition-types/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Pobierz wszystkie typy pozyskania
     * @returns AcquisitionTypeDTO OK
     * @throws ApiError
     */
    public static getAcquisitionTypes(): CancelablePromise<GetAcquisitionTypesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/acquisition-types'
        });
    }
    
    /**
     * Utwórz nowy typ pozyskania
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AcquisitionTypeDTO Created
     * @throws ApiError
     */
    public static postAcquisitionTypes(data: PostAcquisitionTypesData): CancelablePromise<PostAcquisitionTypesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/acquisition-types',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class WelcomeImageControllerService {
    /**
     * @param data The data for the request.
     * @param data.date
     * @returns string OK
     * @throws ApiError
     */
    public static postApiWelcomeImagesGenerate(data: PostApiWelcomeImagesGenerateData): CancelablePromise<PostApiWelcomeImagesGenerateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/welcome-images/generate',
            query: {
                date: data.date
            }
        });
    }
    
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static postApiWelcomeImagesGenerateToday(): CancelablePromise<PostApiWelcomeImagesGenerateTodayResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/welcome-images/generate/today'
        });
    }
    
    /**
     * @returns WelcomeImageResponse OK
     * @throws ApiError
     */
    public static getApiWelcomeImagesToday(): CancelablePromise<GetApiWelcomeImagesTodayResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/welcome-images/today'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.date
     * @param data.timeOfDay
     * @returns WelcomeImageResponse OK
     * @throws ApiError
     */
    public static getApiWelcomeImagesImage(data: GetApiWelcomeImagesImageData): CancelablePromise<GetApiWelcomeImagesImageResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/welcome-images/image',
            query: {
                date: data.date,
                timeOfDay: data.timeOfDay
            }
        });
    }
    
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiWelcomeImagesGenerateNow(): CancelablePromise<GetApiWelcomeImagesGenerateNowResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/welcome-images/generate-now'
        });
    }
    
}

export class UserAvatarControllerService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown OK
     * @throws ApiError
     */
    public static postApiV1UserAvatarsSelect(data: PostApiV1UserAvatarsSelectData): CancelablePromise<PostApiV1UserAvatarsSelectResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/user-avatars/select',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.userId
     * @returns UserAvatarDTO OK
     * @throws ApiError
     */
    public static getApiV1UserAvatarsByUserId(data: GetApiV1UserAvatarsByUserIdData): CancelablePromise<GetApiV1UserAvatarsByUserIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/user-avatars/{userId}',
            path: {
                userId: data.userId
            }
        });
    }
    
    /**
     * @returns AvatarOptionDTO OK
     * @throws ApiError
     */
    public static getApiV1UserAvatarsAvailable(): CancelablePromise<GetApiV1UserAvatarsAvailableResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/user-avatars/available'
        });
    }
    
}

export class TaskAssignmentService {
    /**
     * Assign multiple tasks to a lead
     * Creates associations between a single lead and multiple tasks. This endpoint allows bulk assignment of tasks to a lead, preventing duplicate associations. All specified tasks and the lead must exist in the system.
     * @param data The data for the request.
     * @param data.requestBody Request containing lead ID and list of task IDs to assign
     * @returns unknown Tasks successfully assigned to lead
     * @throws ApiError
     */
    public static postApiLeadTasksAssignTasksToLead(data: PostApiLeadTasksAssignTasksToLeadData): CancelablePromise<PostApiLeadTasksAssignTasksToLeadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/lead-tasks/assign-tasks-to-lead',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad request - Invalid input data or entity not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class LeadTaskManagementService {
    /**
     * Assign multiple tasks to a lead
     * Creates associations between a single lead and multiple tasks. This endpoint allows bulk assignment of tasks to a lead, preventing duplicate associations. All specified tasks and the lead must exist in the system.
     * @param data The data for the request.
     * @param data.requestBody Request containing lead ID and list of task IDs to assign
     * @returns unknown Tasks successfully assigned to lead
     * @throws ApiError
     */
    public static postApiLeadTasksAssignTasksToLead(data: PostApiLeadTasksAssignTasksToLeadData): CancelablePromise<PostApiLeadTasksAssignTasksToLeadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/lead-tasks/assign-tasks-to-lead',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad request - Invalid input data or entity not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Assign multiple leads to a task
     * Creates associations between a single task and multiple leads. This endpoint allows bulk assignment of leads to a task, preventing duplicate associations. All specified leads and the task must exist in the system.
     * @param data The data for the request.
     * @param data.requestBody Request containing task ID and list of lead IDs to assign
     * @returns unknown Leads successfully assigned to task
     * @throws ApiError
     */
    public static postApiLeadTasksAssignLeadsToTask(data: PostApiLeadTasksAssignLeadsToTaskData): CancelablePromise<PostApiLeadTasksAssignLeadsToTaskResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/lead-tasks/assign-leads-to-task',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad request - Invalid input data or entity not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get all leads assigned to a task
     * Retrieves all leads that are currently assigned to the specified task. Returns a stream of Lead objects with complete lead details. The task must exist in the system.
     * @param data The data for the request.
     * @param data.taskId Unique identifier of the task
     * @returns Lead Successfully retrieved leads for the task
     * @throws ApiError
     */
    public static getApiLeadTasksTaskByTaskIdLeads(data: GetApiLeadTasksTaskByTaskIdLeadsData): CancelablePromise<GetApiLeadTasksTaskByTaskIdLeadsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-tasks/task/{taskId}/leads',
            path: {
                taskId: data.taskId
            },
            errors: {
                400: 'Bad request - Task not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get count of leads assigned to a task
     * Returns the total number of leads currently assigned to the specified task. This is a lightweight endpoint that provides quick statistics without returning full lead details.
     * @param data The data for the request.
     * @param data.taskId Unique identifier of the task
     * @returns number Successfully retrieved lead count for the task
     * @throws ApiError
     */
    public static getApiLeadTasksTaskByTaskIdLeadsCount(data: GetApiLeadTasksTaskByTaskIdLeadsCountData): CancelablePromise<GetApiLeadTasksTaskByTaskIdLeadsCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-tasks/task/{taskId}/leads/count',
            path: {
                taskId: data.taskId
            },
            errors: {
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get all tasks assigned to a lead
     * Retrieves all tasks that are currently assigned to the specified lead. Returns a stream of Task objects with complete task details. The lead must exist in the system.
     * @param data The data for the request.
     * @param data.leadId Unique identifier of the lead
     * @returns Task Successfully retrieved tasks for the lead
     * @throws ApiError
     */
    public static getApiLeadTasksLeadByLeadIdTasks(data: GetApiLeadTasksLeadByLeadIdTasksData): CancelablePromise<GetApiLeadTasksLeadByLeadIdTasksResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-tasks/lead/{leadId}/tasks',
            path: {
                leadId: data.leadId
            },
            errors: {
                400: 'Bad request - Lead not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get count of tasks assigned to a lead
     * Returns the total number of tasks currently assigned to the specified lead. This is a lightweight endpoint that provides quick statistics without returning full task details.
     * @param data The data for the request.
     * @param data.leadId Unique identifier of the lead
     * @returns number Successfully retrieved task count for the lead
     * @throws ApiError
     */
    public static getApiLeadTasksLeadByLeadIdTasksCount(data: GetApiLeadTasksLeadByLeadIdTasksCountData): CancelablePromise<GetApiLeadTasksLeadByLeadIdTasksCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-tasks/lead/{leadId}/tasks/count',
            path: {
                leadId: data.leadId
            },
            errors: {
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Check if a task is assigned to a lead
     * Verifies whether a specific task is currently assigned to a specific lead. Returns a boolean value indicating the existence of the association. This is useful for validation and UI state management.
     * @param data The data for the request.
     * @param data.leadId Unique identifier of the lead
     * @param data.taskId Unique identifier of the task
     * @returns boolean Successfully checked association existence
     * @throws ApiError
     */
    public static getApiLeadTasksLeadByLeadIdTaskByTaskIdExists(data: GetApiLeadTasksLeadByLeadIdTaskByTaskIdExistsData): CancelablePromise<GetApiLeadTasksLeadByLeadIdTaskByTaskIdExistsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-tasks/lead/{leadId}/task/{taskId}/exists',
            path: {
                leadId: data.leadId,
                taskId: data.taskId
            },
            errors: {
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Detach multiple tasks from a lead
     * Removes associations between a single lead and multiple tasks. This endpoint allows bulk removal of tasks from a lead. Only existing associations will be removed - non-existent associations are ignored. All specified tasks and the lead must exist in the system.
     * @param data The data for the request.
     * @param data.requestBody Request containing lead ID and list of task IDs to detach
     * @returns unknown Tasks successfully detached from lead
     * @throws ApiError
     */
    public static deleteApiLeadTasksDetachTasksFromLead(data: DeleteApiLeadTasksDetachTasksFromLeadData): CancelablePromise<DeleteApiLeadTasksDetachTasksFromLeadResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/lead-tasks/detach-tasks-from-lead',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad request - Invalid input data or entity not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Detach multiple leads from a task
     * Removes associations between a single task and multiple leads. This endpoint allows bulk removal of leads from a task. Only existing associations will be removed - non-existent associations are ignored. All specified leads and the task must exist in the system.
     * @param data The data for the request.
     * @param data.requestBody Request containing task ID and list of lead IDs to detach
     * @returns unknown Leads successfully detached from task
     * @throws ApiError
     */
    public static deleteApiLeadTasksDetachLeadsFromTask(data: DeleteApiLeadTasksDetachLeadsFromTaskData): CancelablePromise<DeleteApiLeadTasksDetachLeadsFromTaskResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/lead-tasks/detach-leads-from-task',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad request - Invalid input data or entity not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class LeadAssignmentService {
    /**
     * Assign multiple leads to a task
     * Creates associations between a single task and multiple leads. This endpoint allows bulk assignment of leads to a task, preventing duplicate associations. All specified leads and the task must exist in the system.
     * @param data The data for the request.
     * @param data.requestBody Request containing task ID and list of lead IDs to assign
     * @returns unknown Leads successfully assigned to task
     * @throws ApiError
     */
    public static postApiLeadTasksAssignLeadsToTask(data: PostApiLeadTasksAssignLeadsToTaskData): CancelablePromise<PostApiLeadTasksAssignLeadsToTaskResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/lead-tasks/assign-leads-to-task',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad request - Invalid input data or entity not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class LeadImportService {
    /**
     * Importuj kontakty z pliku Excel z śledzeniem postępu
     * Rozpoczyna import kontaktów z pliku Excel i zwraca ID sesji do śledzenia postępu
     * @param data The data for the request.
     * @param data.formData
     * @returns string Import został rozpoczęty
     * @throws ApiError
     */
    public static postApiLeadContactsImportExcelWithProgress(data: PostApiLeadContactsImportExcelWithProgressData = {}): CancelablePromise<PostApiLeadContactsImportExcelWithProgressResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/lead-contacts/import-excel-with-progress',
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: 'Nieprawidłowy plik lub błąd podczas importu'
            }
        });
    }
    
    /**
     * Importuj kontakty z pliku Excel
     * Importuje kontakty z pliku Excel, sprawdza duplikaty i zwraca raport importu
     * @param data The data for the request.
     * @param data.formData
     * @returns LeadImportReportDTO Import został pomyślnie wykonany
     * @throws ApiError
     */
    public static postApiLeadContactsImportExcel(data: PostApiLeadContactsImportExcelData = {}): CancelablePromise<PostApiLeadContactsImportExcelResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/lead-contacts/import-excel',
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: 'Nieprawidłowy plik lub błąd podczas importu'
            }
        });
    }
    
    /**
     * Eksportuj przefiltrowane leady do Excel
     * Eksportuje leady spełniające kryteria filtrowania do pliku Excel
     * @param data The data for the request.
     * @param data.requestBody
     * @returns binary Eksport został pomyślnie wygenerowany
     * @throws ApiError
     */
    public static postApiLeadContactsExportFilteredLeads(data: PostApiLeadContactsExportFilteredLeadsData): CancelablePromise<PostApiLeadContactsExportFilteredLeadsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/lead-contacts/export-filtered-leads',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.importId
     * @returns LeadImportProgressDTO OK
     * @throws ApiError
     */
    public static getApiLeadContactsImportStatusByImportId(data: GetApiLeadContactsImportStatusByImportIdData): CancelablePromise<GetApiLeadContactsImportStatusByImportIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-contacts/import-status/{importId}',
            path: {
                importId: data.importId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.importId
     * @returns ServerSentEventLeadImportProgressDTO OK
     * @throws ApiError
     */
    public static getApiLeadContactsImportProgressByImportId(data: GetApiLeadContactsImportProgressByImportIdData): CancelablePromise<GetApiLeadContactsImportProgressByImportIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-contacts/import-progress/{importId}',
            path: {
                importId: data.importId
            }
        });
    }
    
    /**
     * Pobierz historię importów
     * Zwraca paginowaną listę historii importów kontaktów
     * @param data The data for the request.
     * @param data.page
     * @param data.size
     * @returns unknown Historia importów została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiLeadContactsImportHistory(data: GetApiLeadContactsImportHistoryData = {}): CancelablePromise<GetApiLeadContactsImportHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-contacts/import-history',
            query: {
                page: data.page,
                size: data.size
            }
        });
    }
    
    /**
     * Pobierz historię importu po ID
     * Zwraca szczegóły historii importu o podanym identyfikatorze
     * @param data The data for the request.
     * @param data.importId Identyfikator importu
     * @returns LeadImportHistoryDTO Historia importu została pomyślnie znaleziona
     * @throws ApiError
     */
    public static getApiLeadContactsImportHistoryByImportId(data: GetApiLeadContactsImportHistoryByImportIdData): CancelablePromise<GetApiLeadContactsImportHistoryByImportIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-contacts/import-history/{importId}',
            path: {
                importId: data.importId
            },
            errors: {
                404: 'Historia importu o podanym ID nie została znaleziona'
            }
        });
    }
    
    /**
     * Pobierz historię importów użytkownika
     * Zwraca listę historii importów dla określonego użytkownika
     * @param data The data for the request.
     * @param data.username Nazwa użytkownika
     * @returns LeadImportHistoryDTO Historia importów użytkownika została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiLeadContactsImportHistoryUserByUsername(data: GetApiLeadContactsImportHistoryUserByUsernameData): CancelablePromise<GetApiLeadContactsImportHistoryUserByUsernameResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-contacts/import-history/user/{username}',
            path: {
                username: data.username
            }
        });
    }
    
    /**
     * Eksportuj leady z paginacją do Excel
     * Eksportuje określoną stronę leadów do pliku Excel
     * @param data The data for the request.
     * @param data.page Numer strony (0-based)
     * @param data.size Rozmiar strony
     * @returns binary Eksport został pomyślnie wygenerowany
     * @throws ApiError
     */
    public static getApiLeadContactsExportLeadsPaginated(data: GetApiLeadContactsExportLeadsPaginatedData = {}): CancelablePromise<GetApiLeadContactsExportLeadsPaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-contacts/export-leads-paginated',
            query: {
                page: data.page,
                size: data.size
            }
        });
    }
    
    /**
     * Eksportuj leady z zakresu dat do Excel
     * Eksportuje leady z określonego zakresu dat do pliku Excel
     * @param data The data for the request.
     * @param data.fromDate Data początkowa (yyyy-MM-dd)
     * @param data.toDate Data końcowa (yyyy-MM-dd)
     * @returns binary Eksport został pomyślnie wygenerowany
     * @throws ApiError
     */
    public static getApiLeadContactsExportLeadsByDateRange(data: GetApiLeadContactsExportLeadsByDateRangeData): CancelablePromise<GetApiLeadContactsExportLeadsByDateRangeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-contacts/export-leads-by-date-range',
            query: {
                fromDate: data.fromDate,
                toDate: data.toDate
            }
        });
    }
    
    /**
     * Eksportuj wszystkie leady do Excel
     * Eksportuje wszystkie leady do pliku Excel
     * @returns binary Eksport został pomyślnie wygenerowany
     * @throws ApiError
     */
    public static getApiLeadContactsExportAllLeads(): CancelablePromise<GetApiLeadContactsExportAllLeadsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-contacts/export-all-leads'
        });
    }
    
    /**
     * Pobierz szablon Excel do importu
     * Zwraca plik Excel z szablonem do importu kontaktów
     * @returns binary Szablon został pomyślnie wygenerowany
     * @throws ApiError
     */
    public static getApiLeadContactsExcelTemplate(): CancelablePromise<GetApiLeadContactsExcelTemplateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-contacts/excel-template'
        });
    }
    
}

export class CustomerContactService {
    /**
     * Submit contact form
     * Submit a contact form from website visitors. This endpoint is unsecured and does not require authentication.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns string Contact form submitted successfully
     * @throws ApiError
     */
    public static postApiHelpContact(data: PostApiHelpContactData): CancelablePromise<PostApiHelpContactResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/help/contact',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Invalid input data or failed reCAPTCHA validation',
                500: 'Internal server error'
            }
        });
    }
    
}

export class MinIoFileStorageService {
    /**
     * Wgraj plik
     * Wgrywa plik do magazynu w domenie zalogowanego użytkownika
     * @param data The data for the request.
     * @param data.relatedObjectId ID obiektu powiązanego z plikiem (task, lead, notatka itp.)
     * @param data.relatedObjectType Typ obiektu powiązanego z plikiem (TASK, LEAD, NOTE, COMMENT)
     * @param data.formData
     * @returns unknown Plik został pomyślnie wgrany
     * @throws ApiError
     */
    public static postApiFilesUpload(data: PostApiFilesUploadData = {}): CancelablePromise<PostApiFilesUploadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/files/upload',
            query: {
                relatedObjectId: data.relatedObjectId,
                relatedObjectType: data.relatedObjectType
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: 'Nieprawidłowy plik lub przekroczony limit',
                401: 'Brak autoryzacji',
                500: 'Błąd serwera podczas wgrywania pliku'
            }
        });
    }
    
    /**
     * Zmień status pliku
     * Zmienia status pliku w domenie zalogowanego użytkownika
     * @param data The data for the request.
     * @param data.filename Nazwa pliku do zmiany statusu
     * @param data.status Nowy status pliku (ACTIVE lub DETACHED)
     * @returns string Status pliku został pomyślnie zmieniony
     * @throws ApiError
     */
    public static patchApiFilesByFilenameStatus(data: PatchApiFilesByFilenameStatusData): CancelablePromise<PatchApiFilesByFilenameStatusResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/files/{filename}/status',
            path: {
                filename: data.filename
            },
            query: {
                status: data.status
            },
            errors: {
                400: 'Nieprawidłowy status',
                401: 'Brak autoryzacji',
                404: 'Plik nie został znaleziony'
            }
        });
    }
    
    /**
     * Zmień status wielu plików
     * Zmienia status wielu plików naraz w domenie zalogowanego użytkownika
     * @param data The data for the request.
     * @param data.status Nowy status plików (ACTIVE lub DETACHED)
     * @param data.requestBody
     * @returns unknown Status plików został pomyślnie zmieniony
     * @throws ApiError
     */
    public static patchApiFilesBulkStatus(data: PatchApiFilesBulkStatusData): CancelablePromise<PatchApiFilesBulkStatusResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/files/bulk/status',
            query: {
                status: data.status
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Nieprawidłowe dane wejściowe',
                401: 'Brak autoryzacji',
                404: 'Jeden lub więcej plików nie zostało znalezionych'
            }
        });
    }
    
    /**
     * Lista wszystkich plików w domenie
     * Pobiera listę wszystkich plików w domenie zalogowanego użytkownika
     * @returns unknown Lista plików została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiFiles(): CancelablePromise<GetApiFilesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/files'
        });
    }
    
    /**
     * Pobierz miniaturę obrazu
     * Generuje i zwraca miniaturę obrazu dla pliku z domeny użytkownika
     * @param data The data for the request.
     * @param data.filename Nazwa pliku do utworzenia miniatury
     * @param data.size Rozmiar miniatury (domyślnie 150px)
     * @param data.quality Jakość kompresji JPEG (1-100, domyślnie 85)
     * @returns DataBuffer Miniatura została wygenerowana i zwrócona
     * @throws ApiError
     */
    public static getApiFilesByFilenameThumbnail(data: GetApiFilesByFilenameThumbnailData): CancelablePromise<GetApiFilesByFilenameThumbnailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/files/{filename}/thumbnail',
            path: {
                filename: data.filename
            },
            query: {
                size: data.size,
                quality: data.quality
            },
            errors: {
                400: 'Plik nie jest obrazem lub nie można utworzyć miniatury',
                403: 'Brak uprawnień do pliku z innej domeny',
                404: 'Plik nie został znaleziony'
            }
        });
    }
    
    /**
     * Pobierz plik
     * Generuje URL do pobrania pliku z domeny użytkownika
     * @param data The data for the request.
     * @param data.filename Nazwa pliku do pobrania
     * @returns string URL do pobrania został wygenerowany
     * @throws ApiError
     */
    public static getApiFilesByFilenameDownload(data: GetApiFilesByFilenameDownloadData): CancelablePromise<GetApiFilesByFilenameDownloadResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/files/{filename}/download',
            path: {
                filename: data.filename
            },
            errors: {
                403: 'Brak uprawnień do pliku z innej domeny',
                404: 'Plik nie został znaleziony'
            }
        });
    }
    
    /**
     * Informacje o magazynie
     * Pobiera informacje o wykorzystaniu magazynu w domenie użytkownika
     * @returns unknown Informacje o magazynie zostały pomyślnie pobrane
     * @throws ApiError
     */
    public static getApiFilesStorageInfo(): CancelablePromise<GetApiFilesStorageInfoResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/files/storage-info'
        });
    }
    
    /**
     * Lista plików użytkownika
     * Pobiera listę plików wgranych przez zalogowanego użytkownika w jego domenie
     * @returns FileMetadataDTO Lista plików użytkownika została pomyślnie pobrana
     * @throws ApiError
     */
    public static getApiFilesMyFiles(): CancelablePromise<GetApiFilesMyFilesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/files/my-files'
        });
    }
    
    /**
     * Pliki przypisane do taska lub leada
     * Pobiera pliki przypisane do taska lub leada
     * @param data The data for the request.
     * @param data.id
     * @param data.type
     * @returns FileMetadataDTO Pobiera pliki przypisane do taska lub leada
     * @throws ApiError
     */
    public static getApiFilesByRelatedObjectByIdByType(data: GetApiFilesByRelatedObjectByIdByTypeData): CancelablePromise<GetApiFilesByRelatedObjectByIdByTypeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/files/by-related-object/{id}/{type}',
            path: {
                id: data.id,
                type: data.type
            }
        });
    }
    
    /**
     * Usuń plik
     * Usuwa plik z domeny zalogowanego użytkownika
     * @param data The data for the request.
     * @param data.filename Nazwa pliku do usunięcia
     * @returns void Plik został usunięty
     * @throws ApiError
     */
    public static deleteApiFilesByFilename(data: DeleteApiFilesByFilenameData): CancelablePromise<DeleteApiFilesByFilenameResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/files/{filename}',
            path: {
                filename: data.filename
            },
            errors: {
                403: 'Brak uprawnień do usunięcia pliku z innej domeny',
                404: 'Plik nie został znaleziony'
            }
        });
    }
    
    /**
     * Usuń wiele plików
     * Usuwa wiele plików naraz z domeny zalogowanego użytkownika
     * @param data The data for the request.
     * @param data.requestBody
     * @returns void Pliki zostały usunięte
     * @throws ApiError
     */
    public static deleteApiFilesBulk(data: DeleteApiFilesBulkData): CancelablePromise<DeleteApiFilesBulkResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/files/bulk',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Nieprawidłowe dane wejściowe',
                403: 'Brak uprawnień do usunięcia plików z innej domeny',
                404: 'Jeden lub więcej plików nie zostało znalezionych'
            }
        });
    }
    
}

export class CompanyLogoService {
    /**
     * Get company logo
     * Retrieves the company logo
     * @returns CompanyLogo Logo retrieved successfully
     * @throws ApiError
     */
    public static getApiCompanyLogo(): CancelablePromise<GetApiCompanyLogoResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/company/logo',
            errors: {
                401: 'Unauthorized',
                404: 'Logo not found',
                500: 'Server error'
            }
        });
    }
    
    /**
     * Upload company logo
     * Uploads a logo for the company
     * @param data The data for the request.
     * @param data.formData
     * @returns unknown Logo uploaded successfully
     * @throws ApiError
     */
    public static postApiCompanyLogo(data: PostApiCompanyLogoData = {}): CancelablePromise<PostApiCompanyLogoResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/company/logo',
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: 'Invalid file or size limit exceeded',
                401: 'Unauthorized',
                500: 'Server error during upload'
            }
        });
    }
    
    /**
     * Delete company logo
     * Deletes the company logo
     * @returns unknown Logo deleted successfully
     * @throws ApiError
     */
    public static deleteApiCompanyLogo(): CancelablePromise<DeleteApiCompanyLogoResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/company/logo',
            errors: {
                401: 'Unauthorized',
                500: 'Server error'
            }
        });
    }
    
}

export class RegistrationService {
    /**
     * Complete user registration
     * Completes the user registration process using the provided confirmation token.
     * @param data The data for the request.
     * @param data.token Confirmation token received via email
     * @param data.requestBody
     * @returns RegistrationCompletionResponseDTO Registration completed successfully
     * @throws ApiError
     */
    public static postApiAuthRegisterConfirm(data: PostApiAuthRegisterConfirmData): CancelablePromise<PostApiAuthRegisterConfirmResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/register/confirm',
            query: {
                token: data.token
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Invalid or expired token',
                500: 'Internal server error during registration completion'
            }
        });
    }
    
    /**
     * Register a new domain and user account
     * Registers a new domain based on the provided name and creates an initial user account associated with the provided email, after reCAPTCHA v3 validation.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns RegistrationResponseDTO Registration successful
     * @throws ApiError
     */
    public static postApiAuthRegister(data: PostApiAuthRegisterData): CancelablePromise<PostApiAuthRegisterResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/register',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Invalid input data (e.g., validation errors, failed reCAPTCHA)',
                500: 'Internal server error during registration process'
            }
        });
    }
    
    /**
     * Check if email is already taken
     * Checks if the provided email is already registered in the system.
     * @param data The data for the request.
     * @param data.email Email to check
     * @returns EmailCheckResponseDTO Email check completed
     * @throws ApiError
     */
    public static getApiAuthRegisterCheckEmail(data: GetApiAuthRegisterCheckEmailData): CancelablePromise<GetApiAuthRegisterCheckEmailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/auth/register/check-email',
            query: {
                email: data.email
            },
            errors: {
                400: 'Invalid email format'
            }
        });
    }
    
    /**
     * Check if domain is already taken
     * Checks if the provided domain name is already registered in the system.
     * @param data The data for the request.
     * @param data.domainName Domain name to check
     * @returns DomainCheckResponseDTO Domain check completed
     * @throws ApiError
     */
    public static getApiAuthRegisterCheckDomain(data: GetApiAuthRegisterCheckDomainData): CancelablePromise<GetApiAuthRegisterCheckDomainResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/auth/register/check-domain',
            query: {
                domainName: data.domainName
            },
            errors: {
                400: 'Invalid domain format'
            }
        });
    }
    
}

export class PasswordResetService {
    /**
     * Resetuj hasło
     * Ustawia nowe hasło dla konta, korzystając z poprawnego tokenu
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Hasło zostało zaktualizowane
     * @throws ApiError
     */
    public static postApiAuthPasswordReset(data: PostApiAuthPasswordResetData): CancelablePromise<PostApiAuthPasswordResetResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/password/reset',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Nieprawidłowe dane wejściowe',
                404: 'Token nie istnieje lub jest niepoprawny',
                410: 'Token wygasł',
                500: 'Wewnętrzny błąd serwera'
            }
        });
    }
    
    /**
     * Wyślij link resetujący hasło
     * Wysyła e-mail z tokenem resetu hasła do użytkownika o podanym adresie
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Link resetujący został wysłany
     * @throws ApiError
     */
    public static postApiAuthPasswordResetRequest(data: PostApiAuthPasswordResetRequestData): CancelablePromise<PostApiAuthPasswordResetRequestResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/password/reset-request',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Nieprawidłowe dane wejściowe',
                404: 'Użytkownik nie istnieje',
                500: 'Wewnętrzny błąd serwera'
            }
        });
    }
    
    /**
     * Zweryfikuj token resetu hasła
     * Sprawdza, czy przekazany token resetu hasła jest poprawny i nie wygasł
     * @param data The data for the request.
     * @param data.token Token resetu hasła
     * @returns unknown Token jest poprawny
     * @throws ApiError
     */
    public static getApiAuthPasswordValidate(data: GetApiAuthPasswordValidateData): CancelablePromise<GetApiAuthPasswordValidateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/auth/password/validate',
            query: {
                token: data.token
            },
            errors: {
                404: 'Token nie istnieje lub jest niepoprawny',
                410: 'Token wygasł',
                500: 'Wewnętrzny błąd serwera'
            }
        });
    }
    
}

export class AlertsService {
    /**
     * Pobiera wszystkie alerty w systemie
     * Zwraca listę wszystkich alertów posortowanych po dacie utworzenia
     * @returns AlertDTO OK
     * @throws ApiError
     */
    public static getApiAlerts(): CancelablePromise<GetApiAlertsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/alerts'
        });
    }
    
    /**
     * Tworzy nowy alert dla taska
     * Tworzy alert przypisany do konkretnego taska. Task ID jest wymagane.
     *
     * **Dostępne opcje przypomnienia (remindOption):**
     * - `FIFTEEN_MINUTES` - 15 minut przed
     * - `ONE_HOUR` - 1 godzina przed
     * - `TWO_HOURS` - 2 godziny przed
     * - `THREE_HOURS` - 3 godziny przed
     * - `ONE_DAY` - 1 dzień przed
     *
     * **Przykład JSON:**
     * ```json
     * {
     * "userId": "user123",
     * "taskId": 1,
     * "message": "Pamiętaj o spotkaniu!",
     * "dueDate": "2024-12-25T10:00:00Z",
     * "remindOption": "ONE_HOUR",
     * "channel": "EMAIL"
     * }
     * ```
     *
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AlertDTO OK
     * @throws ApiError
     */
    public static postApiAlerts(data: PostApiAlertsData): CancelablePromise<PostApiAlertsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/alerts',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Oznacza alert jako zakończony
     * @param data The data for the request.
     * @param data.id
     * @returns unknown OK
     * @throws ApiError
     */
    public static postApiAlertsByIdComplete(data: PostApiAlertsByIdCompleteData): CancelablePromise<PostApiAlertsByIdCompleteResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/alerts/{id}/complete',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Oznacza wszystkie alerty użytkownika jako zakończone
     * Znajduje i oznacza wszystkie aktywne alerty należące do danego użytkownika jako zakończone.
     * @param data The data for the request.
     * @param data.userId ID użytkownika
     * @returns unknown Liczba zaktualizowanych alertów
     * @throws ApiError
     */
    public static postApiAlertsUserByUserIdCompleteAll(data: PostApiAlertsUserByUserIdCompleteAllData): CancelablePromise<PostApiAlertsUserByUserIdCompleteAllResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/alerts/user/{userId}/complete-all',
            path: {
                userId: data.userId
            }
        });
    }
    
    /**
     * Oznacza wszystkie przeterminowane alerty jako zakończone
     * Uruchamia proces, który wyszukuje wszystkie aktywne alerty z przeszłą datą 'dueDate' i oznacza je jako zakończone.
     * @returns unknown Liczba zaktualizowanych alertów
     * @throws ApiError
     */
    public static postApiAlertsOverdueComplete(): CancelablePromise<PostApiAlertsOverdueCompleteResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/alerts/overdue/complete'
        });
    }
    
    /**
     * Pobiera wszystkie alerty użytkownika
     * @param data The data for the request.
     * @param data.userId
     * @returns AlertDTO OK
     * @throws ApiError
     */
    public static getApiAlertsUserByUserId(data: GetApiAlertsUserByUserIdData): CancelablePromise<GetApiAlertsUserByUserIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/alerts/user/{userId}',
            path: {
                userId: data.userId
            }
        });
    }
    
    /**
     * Pobiera alerty użytkownika dla konkretnego taska
     * @param data The data for the request.
     * @param data.userId ID użytkownika
     * @param data.taskId ID taska
     * @returns AlertDTO OK
     * @throws ApiError
     */
    public static getApiAlertsUserByUserIdTaskByTaskId(data: GetApiAlertsUserByUserIdTaskByTaskIdData): CancelablePromise<GetApiAlertsUserByUserIdTaskByTaskIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/alerts/user/{userId}/task/{taskId}',
            path: {
                userId: data.userId,
                taskId: data.taskId
            }
        });
    }
    
    /**
     * Pobiera alerty użytkownika według statusu
     * @param data The data for the request.
     * @param data.userId
     * @param data.done
     * @returns AlertDTO OK
     * @throws ApiError
     */
    public static getApiAlertsUserByUserIdStatus(data: GetApiAlertsUserByUserIdStatusData): CancelablePromise<GetApiAlertsUserByUserIdStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/alerts/user/{userId}/status',
            path: {
                userId: data.userId
            },
            query: {
                done: data.done
            }
        });
    }
    
    /**
     * Pobiera wszystkie alerty dla konkretnego taska
     * @param data The data for the request.
     * @param data.taskId ID taska
     * @returns AlertDTO OK
     * @throws ApiError
     */
    public static getApiAlertsTaskByTaskId(data: GetApiAlertsTaskByTaskIdData): CancelablePromise<GetApiAlertsTaskByTaskIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/alerts/task/{taskId}',
            path: {
                taskId: data.taskId
            }
        });
    }
    
    /**
     * Pobiera alerty taska według statusu
     * @param data The data for the request.
     * @param data.taskId ID taska
     * @param data.done Status zakończenia
     * @returns AlertDTO OK
     * @throws ApiError
     */
    public static getApiAlertsTaskByTaskIdStatus(data: GetApiAlertsTaskByTaskIdStatusData): CancelablePromise<GetApiAlertsTaskByTaskIdStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/alerts/task/{taskId}/status',
            path: {
                taskId: data.taskId
            },
            query: {
                done: data.done
            }
        });
    }
    
    /**
     * Pobiera alerty według statusu
     * @param data The data for the request.
     * @param data.done
     * @returns AlertDTO OK
     * @throws ApiError
     */
    public static getApiAlertsStatus(data: GetApiAlertsStatusData): CancelablePromise<GetApiAlertsStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/alerts/status',
            query: {
                done: data.done
            }
        });
    }
    
    /**
     * Pobiera dostępne opcje przypomnienia
     * Zwraca listę wszystkich dostępnych opcji przypomnienia z opisami
     * @returns unknown Lista opcji przypomnienia
     * @throws ApiError
     */
    public static getApiAlertsRemindOptions(): CancelablePromise<GetApiAlertsRemindOptionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/alerts/remind-options'
        });
    }
    
}

export class AnalyticsControllerService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.origin
     * @param data.referer
     * @returns string OK
     * @throws ApiError
     */
    public static postAnalytics(data: PostAnalyticsData): CancelablePromise<PostAnalyticsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/analytics',
            headers: {
                Origin: data.origin,
                Referer: data.referer
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class LogoService {
    /**
     * Get company logo by filename
     * Retrieves the company logo image from storage by filename. This endpoint is public and doesn't require authentication.
     * @param data The data for the request.
     * @param data.filename Logo filename
     * @returns binary Logo retrieved successfully
     * @throws ApiError
     */
    public static getLogoByFilename(data: GetLogoByFilenameData): CancelablePromise<GetLogoByFilenameResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/logo/{filename}',
            path: {
                filename: data.filename
            },
            errors: {
                400: 'Invalid filename or file extension not allowed',
                404: 'Logo not found',
                500: 'Server error while retrieving logo'
            }
        });
    }
    
}

export class GlobalSearchService {
    /**
     * Wyszukiwanie w określonym typie obiektów
     * Wyszukuje podaną frazę tylko w określonym typie obiektów:
     * - **COMMENT**: tylko w komentarzach
     * - **TASK**: tylko w zadaniach
     * - **LEAD**: tylko w leadach (kontaktach)
     * - **NOTE**: tylko w notatkach (plikach typu NOTE)
     * - **FILE**: tylko w plikach (wszystkie pliki)
     *
     * Przydatne gdy użytkownik wie czego szuka i chce zawęzić wyniki.
     *
     * @param data The data for the request.
     * @param data.searchTerm Fraza do wyszukania (minimum 2 znaki)
     * @param data.type Typ obiektu do przeszukania
     * @returns SearchResultDTO Wyniki wyszukiwania zwrócone pomyślnie
     * @throws ApiError
     */
    public static getApiSearchByType(data: GetApiSearchByTypeData): CancelablePromise<GetApiSearchByTypeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/search/by-type',
            query: {
                searchTerm: data.searchTerm,
                type: data.type
            },
            errors: {
                400: 'Nieprawidłowe parametry wyszukiwania',
                401: 'Brak autoryzacji'
            }
        });
    }
    
    /**
     * Globalne wyszukiwanie
     * Wyszukuje podaną frazę w całej aplikacji CRM:
     * - **Komentarze**: przeszukuje treść, autora i wzmiankowanych użytkowników
     * - **Zadania**: przeszukuje tytuł, opis, status, typ, priorytet, użytkowników
     * - **Leady (Kontakty)**: przeszukuje imię, nazwisko, email, telefon, miasto, NIP
     * - **Notatki**: przeszukuje nazwy plików i użytkowników (tylko pliki typu NOTE)
     * - **Pliki**: przeszukuje nazwy plików, typy zawartości, użytkowników (wszystkie pliki)
     *
     * Wyniki są sortowane według relevancji (najlepsze dopasowania na górze).
     * Maksymalnie zwracanych jest 50 wyników dla wydajności.
     *
     * @param data The data for the request.
     * @param data.searchTerm Fraza do wyszukania (minimum 2 znaki). Wyszukiwanie jest case-insensitive.
     * @returns SearchResultDTO Wyniki wyszukiwania zwrócone pomyślnie
     * @throws ApiError
     */
    public static getApiSearch(data: GetApiSearchData): CancelablePromise<GetApiSearchResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/search',
            query: {
                searchTerm: data.searchTerm
            },
            errors: {
                400: 'Nieprawidłowe parametry wyszukiwania (fraza za krótka)',
                401: 'Brak autoryzacji',
                500: 'Błąd serwera podczas wyszukiwania'
            }
        });
    }
    
}

export class ReportsService {
    /**
     * Raport czasu w statusach zadania
     * Zwraca raport pokazujący ile dni zadanie spędziło w każdym statusie. Dynamika pracy nad zadaniem.
     * @param data The data for the request.
     * @param data.taskId
     * @returns TaskStatusDurationReportDTO OK
     * @throws ApiError
     */
    public static getApiReportsTasksByTaskIdStatusDuration(data: GetApiReportsTasksByTaskIdStatusDurationData): CancelablePromise<GetApiReportsTasksByTaskIdStatusDurationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/tasks/{taskId}/status-duration',
            path: {
                taskId: data.taskId
            }
        });
    }
    
    /**
     * Podsumowanie statusów zadań
     * Zwraca liczbę zadań w każdym ze statusów (TODO, IN_PROGRESS, CANCELED, DONE)
     * @returns TaskStatusSummaryDTO OK
     * @throws ApiError
     */
    public static getApiReportsTasksStatusSummary(): CancelablePromise<GetApiReportsTasksStatusSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/tasks/status-summary'
        });
    }
    
    /**
     * Raport liczby tasków
     * Zwraca liczbę tasków utworzonych w różnych przedziałach czasowych: 7, 14 i 30 dni
     * @returns TasksCountReportDTO OK
     * @throws ApiError
     */
    public static getApiReportsTasksLastDaysCount(): CancelablePromise<GetApiReportsTasksLastDaysCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/tasks/last-days-count'
        });
    }
    
    /**
     * Raport liczby leadów
     * Zwraca liczbę kontaktów Lead dodanych w różnych przedziałach czasowych: 7, 14, 30 i 60 dni
     * @returns LeadsCountReportDTO OK
     * @throws ApiError
     */
    public static getApiReportsLeadsLastDaysCount(): CancelablePromise<GetApiReportsLeadsLastDaysCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/leads/last-days-count'
        });
    }
    
}

export class LeadRetrievalService {
    /**
     * Get all leads assigned to a task
     * Retrieves all leads that are currently assigned to the specified task. Returns a stream of Lead objects with complete lead details. The task must exist in the system.
     * @param data The data for the request.
     * @param data.taskId Unique identifier of the task
     * @returns Lead Successfully retrieved leads for the task
     * @throws ApiError
     */
    public static getApiLeadTasksTaskByTaskIdLeads(data: GetApiLeadTasksTaskByTaskIdLeadsData): CancelablePromise<GetApiLeadTasksTaskByTaskIdLeadsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-tasks/task/{taskId}/leads',
            path: {
                taskId: data.taskId
            },
            errors: {
                400: 'Bad request - Task not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class StatisticsService {
    /**
     * Get count of leads assigned to a task
     * Returns the total number of leads currently assigned to the specified task. This is a lightweight endpoint that provides quick statistics without returning full lead details.
     * @param data The data for the request.
     * @param data.taskId Unique identifier of the task
     * @returns number Successfully retrieved lead count for the task
     * @throws ApiError
     */
    public static getApiLeadTasksTaskByTaskIdLeadsCount(data: GetApiLeadTasksTaskByTaskIdLeadsCountData): CancelablePromise<GetApiLeadTasksTaskByTaskIdLeadsCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-tasks/task/{taskId}/leads/count',
            path: {
                taskId: data.taskId
            },
            errors: {
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get count of tasks assigned to a lead
     * Returns the total number of tasks currently assigned to the specified lead. This is a lightweight endpoint that provides quick statistics without returning full task details.
     * @param data The data for the request.
     * @param data.leadId Unique identifier of the lead
     * @returns number Successfully retrieved task count for the lead
     * @throws ApiError
     */
    public static getApiLeadTasksLeadByLeadIdTasksCount(data: GetApiLeadTasksLeadByLeadIdTasksCountData): CancelablePromise<GetApiLeadTasksLeadByLeadIdTasksCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-tasks/lead/{leadId}/tasks/count',
            path: {
                leadId: data.leadId
            },
            errors: {
                500: 'Internal server error'
            }
        });
    }
    
}

export class TaskRetrievalService {
    /**
     * Get all tasks assigned to a lead
     * Retrieves all tasks that are currently assigned to the specified lead. Returns a stream of Task objects with complete task details. The lead must exist in the system.
     * @param data The data for the request.
     * @param data.leadId Unique identifier of the lead
     * @returns Task Successfully retrieved tasks for the lead
     * @throws ApiError
     */
    public static getApiLeadTasksLeadByLeadIdTasks(data: GetApiLeadTasksLeadByLeadIdTasksData): CancelablePromise<GetApiLeadTasksLeadByLeadIdTasksResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-tasks/lead/{leadId}/tasks',
            path: {
                leadId: data.leadId
            },
            errors: {
                400: 'Bad request - Lead not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class ValidationService {
    /**
     * Check if a task is assigned to a lead
     * Verifies whether a specific task is currently assigned to a specific lead. Returns a boolean value indicating the existence of the association. This is useful for validation and UI state management.
     * @param data The data for the request.
     * @param data.leadId Unique identifier of the lead
     * @param data.taskId Unique identifier of the task
     * @returns boolean Successfully checked association existence
     * @throws ApiError
     */
    public static getApiLeadTasksLeadByLeadIdTaskByTaskIdExists(data: GetApiLeadTasksLeadByLeadIdTaskByTaskIdExistsData): CancelablePromise<GetApiLeadTasksLeadByLeadIdTaskByTaskIdExistsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-tasks/lead/{leadId}/task/{taskId}/exists',
            path: {
                leadId: data.leadId,
                taskId: data.taskId
            },
            errors: {
                500: 'Internal server error'
            }
        });
    }
    
}

export class LeadSearchService {
    /**
     * Szybkie wyszukiwanie kontaktów
     * Wyszukuje kontakty po firstName, lastName, city, phone, email. Wymaga minimum 3 znaków. Wyniki są cache'owane.
     * @param data The data for the request.
     * @param data.q Fraza do wyszukania (minimum 3 znaki)
     * @returns LeadDTO Wyszukiwanie zakończone pomyślnie
     * @throws ApiError
     */
    public static getApiLeadContactsSearch(data: GetApiLeadContactsSearchData): CancelablePromise<GetApiLeadContactsSearchResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/lead-contacts/search',
            query: {
                q: data.q
            },
            errors: {
                400: 'Nieprawidłowy parametr wyszukiwania (za krótki)'
            }
        });
    }
    
}

export class CarouselControllerService {
    /**
     * @returns CarouselStats OK
     * @throws ApiError
     */
    public static getApiCarouselStats(): CancelablePromise<GetApiCarouselStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/carousel/stats'
        });
    }
    
    /**
     * @returns DailyCarouselImageResponse OK
     * @throws ApiError
     */
    public static getApiCarouselDailyImage(): CancelablePromise<GetApiCarouselDailyImageResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/carousel/daily-image'
        });
    }
    
}

export class TaskRemovalService {
    /**
     * Detach multiple tasks from a lead
     * Removes associations between a single lead and multiple tasks. This endpoint allows bulk removal of tasks from a lead. Only existing associations will be removed - non-existent associations are ignored. All specified tasks and the lead must exist in the system.
     * @param data The data for the request.
     * @param data.requestBody Request containing lead ID and list of task IDs to detach
     * @returns unknown Tasks successfully detached from lead
     * @throws ApiError
     */
    public static deleteApiLeadTasksDetachTasksFromLead(data: DeleteApiLeadTasksDetachTasksFromLeadData): CancelablePromise<DeleteApiLeadTasksDetachTasksFromLeadResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/lead-tasks/detach-tasks-from-lead',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad request - Invalid input data or entity not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class LeadRemovalService {
    /**
     * Detach multiple leads from a task
     * Removes associations between a single task and multiple leads. This endpoint allows bulk removal of leads from a task. Only existing associations will be removed - non-existent associations are ignored. All specified leads and the task must exist in the system.
     * @param data The data for the request.
     * @param data.requestBody Request containing task ID and list of lead IDs to detach
     * @returns unknown Leads successfully detached from task
     * @throws ApiError
     */
    public static deleteApiLeadTasksDetachLeadsFromTask(data: DeleteApiLeadTasksDetachLeadsFromTaskData): CancelablePromise<DeleteApiLeadTasksDetachLeadsFromTaskResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/lead-tasks/detach-leads-from-task',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad request - Invalid input data or entity not found',
                500: 'Internal server error'
            }
        });
    }
    
}